<template>
  <!-- 下单有礼 复购 首单专享礼 -->
  <div class="createPlayStep new-input-box">
    <!-- 头部返回 -->
    <div class="backBox">
      <!-- <img
        class="pointer"
        @click="returnBack()"
        src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/pages/back.svg"
        alt=""
      /> -->
      <jd-button
        type="blue"
        :styleTextObj="{
          width: '44px',
          height: '24px',
          'line-height': '24px',
          padding: '0 8px',
          'min-width': '44px',
        }"
        @click="returnBack()"
        >返回</jd-button
      >
      <span class="backBox_name">{{ activityData.name }}</span>
    </div>
    <div class="formBox">
      <!-- 步骤条 -->
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="localStep">
          <!-- <el-step title="活动模板"></el-step> -->
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>
      <!-- 选中活动模板 -->
      <!--  活动条件表单部分 -->
      <div v-loading="fromLoading" class="secondstep">
        <div style="margin-bottom: 16px;">
          <template v-if="venderType">
            <jd-tip v-if="orderCRM">
              <p>
                1、自营店铺需要搭配<span style="color: #fe4d45">云短信CRM</span
                >使用,<span
                  style="color: #fe4d45"
                  @click="handleCreate"
                  class="pointer"
                  >前往订购>></span
                >
              </p>
              <p>2、订单完成后发放奖励。</p>
            </jd-tip>
            <jd-tip v-else>
              <p>
                1、云短信CRM：订购到期时间
                {{ orderCRMtime }}（自营店铺需要搭配<span
                  @click="handleCreate"
                  class="pointer"
                  style="color: #fe4d45"
                  >云短信CRM</span
                >使用）。
              </p>
              <p>2、订单完成后发放奖励。</p>
            </jd-tip>
          </template>
          <template v-else>
            <jd-tip>
              <p>1、订单完成后发放奖励。</p>
            </jd-tip>
          </template>
        </div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          class="backgroundForm"
          label-width="145px"
        >
          <!-- 下单有礼 -->
          <!-- <jd-title label="基本信息" type="bold" /> -->
          <template>


          <informationForm
            @selectPeopleSure="selectPeopleSure" 
            :backgroundOpacity="backgroundOpacity"
            :defaultActMember.sync="actMember" 
            :defaultActivityStartTime.sync="ruleForm.activityStartTime" 
            :defaultActivityEndTime.sync="ruleForm.activityEndTime" 
            :plusObject.sync="ruleDto.plusObject" 
            :isCheckOpenCardTime.sync="ruleDto.isCheckOpenCardTime" 
            :openCardStartTime.sync="ruleDto.openCardStartTime" 
            :openCardEndTime.sync="ruleDto.openCardEndTime" 
            :peopleSelected.sync="peopleSelected"
            ref="informationForm" 
            v-model="ruleForm" 
            :disabled="isStart" 
            :localStepNum="localStepNum"
            :needNonMember="activityData.id == 16 || activityData.id == 17 || activityData.id == 18" 
            :activityId="activityData.id"
            :customerPaperwork="customerPaperwork"
            @handlCorwdTips="customerPaperwork = $event;$forceUpdate()"
            >
          </informationForm>


            <jd-title>
              <div
                slot="slotBox"
                style="font-weight: bold; font-size: 14px; color: #1f1f1f"
              >
                {{
                  activityData.id == 16
                    ? "下单规则"
                    : activityData.id == 17
                    ? "首单专享礼规则"
                    : "复购及奖品规则"
                }}
                <i class="el-icon-question nong_fu_icon" v-if="isNongfu">
                  <span class="tips"
                    >条件一与条件二为“且”关系，设置后用户需同时满足条件一与条件二才可获奖</span
                  >
                </i>
              </div>
            </jd-title>
            <el-form-item
              label-width="160px"
              v-if="activityData.id != 16"
              :label="activityData.id == 18 ? '复购规则:' : '首单专享礼规则:'"
              :required="activityData.id == 17 ? true : false"
            >
              <!-- 复购 -->
              <template v-if="activityData.id == 18">
                <el-radio
                  v-model="ruleForm.joinType"
                  :label="0"
                  :disabled="isStart"
                  >已完成首购用户</el-radio
                >
                <el-radio
                  v-model="ruleForm.joinType"
                  :label="1"
                  :disabled="isStart"
                >
                  <span>近</span>
                  <el-input
                    style="width: 100px; margin: 0 8px"
                    v-model="ruleForm.days"
                    :disabled="isStart || ruleForm.joinType != 1"
                    @input="ruleForm.days = handleInput($event)"
                    @blur="updateInputBox"
                    @change="handleChange"
                  />
                  <span>天内已购 </span>
                  <el-tooltip
                    class="item"
                    effect="light"
                    trigger="focus"
                    placement="bottom"
                  >
                    <div slot="content">
                      <div>
                        1.
                        只能对系统已从平台拉取到的订单进行判断，可能存在历史存量订单无法判断的情况，因此请根据店铺授权时间进行合理设置，最大时间建议不超过90天；
                      </div>
                      <div>
                        2.
                        该配置要求参与的用户需在店铺已进行开卡入会，未入会用户会引导入会
                      </div>
                      <div>
                        3. 从活动设置的下单开始时间往前近{{
                          ruleForm.days
                        }}天有购买的客户
                        （不包括下单开始时间）且在下单开始时间后有购买且符合参与规则的用户
                      </div>
                    </div>
                    <i
                      class="el-icon-question"
                      style="cursor: pointer; color: rgb(204, 204, 204)"
                    ></i>
                  </el-tooltip>
                </el-radio>
                <el-radio
                  v-model="ruleForm.joinType"
                  :label="2"
                  :disabled="isStart"
                >
                  <span class="mr-8">用户在</span>
                   <div class="my_select_time">
                    <el-date-picker
                      prefix-icon="no_icon"
                      v-model="ruleForm.orderFinishStartTime"
                      type="datetime"
                      placeholder="开始日期"
                      size="small"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      style="width: 185px; font-size: 12px"
                      class="time1"
                      :clearable="false"
                      :disabled="isStart"
                      default-time="00:00:00"
                      :picker-options="orderFinishStartPickerOptions"
                    >
                    </el-date-picker>
                    <div class="time_to_text">至</div>
                    <el-date-picker
                      prefix-icon="no_icon"
                      v-model="ruleForm.orderFinishEndTime"
                      type="datetime"
                      placeholder="结束日期"
                      size="small"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      style="width: 200px; font-size: 12px"
                      class="time2"
                      :clearable="false"
                      :disabled="isStart"
                      default-time="23:59:59"
                      :picker-options="orderFinishEndPickerOptions"
                    >
                    </el-date-picker>
                    <i
                      class="el-icon-circle-close date_icon1"
                      v-if="!isStart"
                      @click="clearReOrderTime"
                    ></i>
                    <img
                      src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                      alt=""
                      class="date_icon2"
                    />
                  </div>
                  <span class="ml-8">期间内有完成订单 </span>
                  <el-tooltip
                    class="item"
                    effect="light"
                    trigger="focus"
                    placement="bottom"
                  >
                    <div slot="content">
                      <div>
                        1. 只能对系统已从平台拉取到的订单进行判断，可能存在历史存量订单无法判断的情况，因此请根据店铺授权时间进行合理设置，最大时间建议距离当前时间不超过90天；
                      </div>
                      <div>
                      2. 该配置要求参与的用户需在店铺已进行开卡入会，未入会用户会引导入会；
                      </div>
                      <div>
                       3. 从活动设置的下单开始时间至结束时间内有购买的客户 （不包括下单开始时间和结束时间）且在下单开始时间至结束时间内有购买且符合参与规则的用户
                      </div>
                    </div>
                    <i
                      class="el-icon-question"
                      style="cursor: pointer; color: rgb(204, 204, 204)"
                    ></i>
                  </el-tooltip>
                </el-radio>
              </template>
              <template v-else>
                <el-radio-group
                  v-model="ruleForm.firstBuyRule"
                  :disabled="isStart"
                >
                  <el-radio :label="0">历史首单</el-radio>
                  <el-radio :label="1">
                    <span>365天首单</span>
                    <el-tooltip
                      class="item"
                      effect="dark"
                      content="历史首单是同品牌多店会员时是品牌历史首单，非店铺历史首单"
                      placement="right"
                    >
                      <i style="marginleft: 5px" class="el-icon-question"></i>
                    </el-tooltip>
                  </el-radio>
                </el-radio-group>
              </template>
            </el-form-item>
            <el-form-item
              label="参与规则:"
              required
              v-if="activityData.id != 18"
            >
              <span
                >{{activityData.id == 17 ? "下单付款并确认收货后即可参与活动（预售商品需要支付尾款并确认收货才可参与活动）" : "下单付款后即可参与活动（预售商品需要支付尾款才可参与活动）"}}</span
              >
              <div class="rule_box">
                <div class="rule_box_top">所下订单需满足如下条件</div>
                <div class="rule_box_middle">
                  <el-form-item label="下单店铺:" required>
                    <div class="flexc">
                      <el-checkbox-group
                        v-model="ruleDto.venderIds"
                        @change="checkShopChange"
                      >
                        <el-checkbox
                          :label="item.venderId"
                          v-for="item in shopList"
                          :key="item.venderId"
                          :disabled="
                            item.venderId == venderId || activityData.isStart
                          "
                          >{{ item.shopTitle }}</el-checkbox
                        >
                        <el-tooltip effect="light" placement="top">
                          <template #content>
                            <div>1.当前店铺默认勾选，且不可取消勾选；</div>
                            <div>
                              2.仅展示当前账号有权限且为同一会员体系下的店铺；
                            </div>
                            <div>
                              3.多店情况下支持用户对活动范围内的店铺订单进行解锁。
                            </div>
                          </template>
                          <el-button type="text" style="width: 35px">
                            <i class="el-icon-question grey-color"></i>
                          </el-button>
                        </el-tooltip>
                      </el-checkbox-group>
                    </div>
                  </el-form-item>
                  <el-form-item label="下单时间:" required>
                    <div class="my_select_time">
                      <el-date-picker
                        prefix-icon="no_icon"
                        v-model="ruleForm.orderStartTime"
                        type="datetime"
                        placeholder="开始日期"
                        size="small"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        style="width: 190px; font-size: 12px"
                        default-time="00:00:00"
                        class="time1"
                        @change="orderChange"
                        @focus="orderFocus(2)"
                        :clearable="false"
                        :picker-options="pickerOrderStart"
                      >
                      </el-date-picker>
                      <div class="time_to_text">至</div>
                      <el-date-picker
                        prefix-icon="no_icon"
                        v-model="ruleForm.orderEndTime"
                        type="datetime"
                        placeholder="结束日期"
                        size="small"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        style="width: 195px; font-size: 12px"
                        default-time="23:59:59"
                        class="time2"
                        @change="orderChange"
                        @focus="orderFocus(2)"
                        :clearable="false"
                        :picker-options="pickerOrderEnd"
                      >
                      </el-date-picker>
                      <i
                        v-if="!isStart"
                        class="el-icon-circle-close date_icon1"
                        @click="clearOrderTime()"
                      ></i>
                      <img
                        src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                        alt=""
                        class="date_icon2"
                      />
                    </div>
                    <el-tooltip
                      class="item"
                      effect="light"
                      content="订单验证时间不得超过100天"
                      placement="bottom"
                    >
                      <el-button type="text" style="width: 35px">
                        <i class="el-icon-question" style="color: #ccc"></i>
                      </el-button>
                    </el-tooltip>
                    <div class="act-tip" v-if="isShowTip">
                      *提示：修改下单时间活动条件不会改变已参与用户的数据状态，修改仅适用于新用户参与活动的判定
                    </div>
                  </el-form-item>
                  <el-form-item label="金额统计类型:" required>
                    <el-radio-group
                      v-model="ruleForm.popOrderStartPaymentType"
                      :disabled="activityData.isStart"
                    >
                      <el-radio :label="1">
                        <span>订单金额（后台价）</span>
                        <el-tooltip class="item" effect="dark" content="是指京东后台价，不等于商城前台页面展示的价格，前台页面无法查看该后台价格；如需查询后台价格，请联系采销核实。" placement="top-start">
                          <div class="new-icon-box" style="margin: -3px 8px"></div>
                        </el-tooltip>
                      </el-radio>
                      <el-radio :label="0" v-if="selectShopsType==2">
                        <span>用户应付金额</span>
                        <el-tooltip class="item" effect="dark" content="订单商品原价总额-订单优惠总额+订单运费+税费+调整运费金额=用户应付金额" placement="top-start">
                          <div class="new-icon-box" style="margin: -3px 8px"></div>
                        </el-tooltip>
                      </el-radio>
                      <el-radio :label="2" v-if="selectShopsType==2">
                        <span>用户实付金额</span>
                        <el-tooltip class="item" effect="dark" content="用户应付金额-支付优惠总额=用户实付金额" placement="top-start">
                          <div class="new-icon-box" style="margin: -3px 8px"></div>
                        </el-tooltip>
                      </el-radio>
                    </el-radio-group>
                    <div class="memberTips" style="margin-right: 30px">
                      注意：由于接口原因，自营仅支持统计订单金额，pop可按需选择统计实付金额或订单金额。
                    </div>
                  </el-form-item>
                  <!-- 1.14迭代 -->
                  <template v-if="!isNongfu">
                    <el-form-item label="订单金额:" required>
                      大于等于
                      <el-input
                        v-model="ruleForm.orderStartPayment"
                        @input="
                          ruleForm.orderStartPayment = setNumber(
                            $event,
                            1,
                            true
                          )
                        "
                        @change="changDays()"
                        style="width: 140px"
                        placeholder="请输入"
                        :disabled="isStart"
                      ></el-input>
                      &nbsp; 元 &nbsp;
                      <!-- &nbsp; 元- &nbsp;
                      <el-input
                        v-model="ruleForm.orderEndPayment"
                        @input="ruleForm.orderEndPayment = getNumberData(1, $event, 1, 0)"
                        @change="changDays()"
                        style="width:140px"
                        placeholder="请输入"
                        :disabled="isStart"
                      ></el-input
                      >&nbsp; 元<br> -->
                      <!-- <span style="color:red;margin-left:0px">注意：由于接口原因，pop支持统计实付金额，自营仅支持统计订单金额。</span> -->
                    </el-form-item>
                    <el-form-item label="商品件数:" width="">
                      大于等于
                      <el-input
                        v-model="ruleForm.orderStartCount"
                        @input="
                          ruleForm.orderStartCount = setNumber($event, 1, true)
                        "
                        @change="changDays()"
                        style="width: 140px"
                        placeholder="请输入"
                        :disabled="isStart"
                      ></el-input>
                      &nbsp; 件 &nbsp;
                      <!-- &nbsp; 件- &nbsp;
                      <el-input
                        v-model="ruleForm.orderEndCount"
                        @input="ruleForm.orderEndCount = getNumberData(1, $event, 0, 1)"
                        @change="changDays()"
                        style="width:140px"
                        placeholder="请输入"
                        :disabled="isStart"
                      ></el-input
                      >&nbsp; 件 -->
                    </el-form-item>
                  </template>
                  <el-form-item label="指定购买商品:" required v-if="!isNongfu">
                    <el-radio
                      v-model="ruleForm.filterType"
                      @change="filterTypeChange"
                      label="0"
                      :disabled="isStart"
                    >
                      全部商品
                    </el-radio>
                    <el-radio
                      v-model="ruleForm.filterType"
                      @change="filterTypeChange"
                      label="1"
                      :disabled="isStart"
                      >指定商品</el-radio
                    >
                    <el-radio
                      v-model="ruleForm.filterType"
                      @change="filterTypeChange"
                      label="2"
                      :disabled="isStart"
                      >排除商品</el-radio
                    >
                    <jd-button
                      v-if="ruleDto.venderIds.length == 1"
                      :disabled="ruleForm.filterType == 0 || isStart"
                      @click="orderSelectGoods(venderId)"
                    >
                      {{
                        ruleDto.sellerSkuList.length
                          ? `已选择(${ruleDto.sellerSkuList[0] && ruleDto.sellerSkuList[0].skuIds.length || 0}个)`
                          : "+添加"
                      }}
                    </jd-button>
                    <div v-else-if="ruleDto.venderIds.length > 1 && ruleForm.filterType != 0">
                      <div v-for="item in ruleDto.sellerSkuList" :key="item.venderId">
                        <div class="flexc-cen-x mb8">
                          <div class="shoptitle-label">{{getTitle(item.venderId)}}</div>
                          <jd-button @click="orderSelectGoods(item.venderId)" v-loading="skuIdListLoading"
                            :disabled="activityData.isStart">
                            已选择
                            {{item.skuIds.length }}个
                          </jd-button>
                        </div>
                      </div>
                    </div>
                  </el-form-item>
                  <el-form-item label="指定商品规则:" v-if="ruleForm.popOrderStartPaymentType==1&&(activityData.id ==16||activityData.id == 17)&&ruleForm.filterType==1">
                    <el-select  
                      v-model="ruleDto.filterSkuType" :disabled="activityData.isStart"
                      placeholder="请选择" style="width: 270px;">
                      <el-option
                        label="只要订单包含指定商品就整单计算"
                        :value="0"
                      >
                      </el-option>
                      <el-option
                        label="仅统计订单内指定商品的金额和件数"
                        :value="1"
                      >
                      </el-option>
                    </el-select>
                    <jd-button type="blueText" class="ml12" @click="viewStatisticsLogic">查看统计逻辑</jd-button>
                  </el-form-item>
                  <el-form-item label="订单拆单后是否合并:" label-width="160px" required>
                    <el-radio-group
                      :disabled="activityData.isStart"
                      v-model="ruleForm.mergeOrder"
                    >
                      <el-radio :label="false">否</el-radio>
                      <el-radio :label="true">是</el-radio>
                    </el-radio-group>
                    <jd-button type="blueText" class="ml12" @click="viewMergeLogic">查看合并拆单逻辑</jd-button>
                  </el-form-item>
                  <el-form-item label="C端选择订单号:">
                    <div class="support">
                      <el-checkbox
                        v-model="ruleForm.isSupportOrderList"
                        :disabled="isStart"
                        :false-label="0"
                        :true-label="1"
                      ></el-checkbox>
                      <span class="support-text"
                        >用户参与活动时支持选择订单号，无需手动输入</span
                      >
                      <el-popover placement="top-start" trigger="hover">
                        <i
                          slot="reference"
                          class="el-icon-question support-icon"
                        ></i>
                        <div>
                          <img
                            src="https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/orderList_preview.png"
                            alt=""
                          />
                        </div>
                      </el-popover>
                    </div>
                  </el-form-item>
                </div>
              </div>
            </el-form-item>
            <el-form-item
              label="参与规则与奖品设置:"
              label-width="160px"
              required
              v-else
            >
              <div>
                1.下单付款后即可参与活动（预售商品需要支付尾款才可参与活动）
              </div>
              <div>
                2.参与活动用户在订单完成后才可领取奖品,整个活动期内每人只可领取1次及其中1个奖品
              </div>
              <div>
                <el-radio-group
                  v-model="ruleForm.prizeSettingType"
                  :disabled="isStart"
                  @change="handleSettingType"
                >
                  <el-radio :label="0">统一奖品</el-radio>
                  <el-radio :label="1">阶梯奖品</el-radio>
                </el-radio-group>
              </div>
              <div class="rule_box">
                <div class="rule_box_top">所下订单需满足如下条件</div>
                <div class="rule_box_middle">
                  <el-form-item label="下单店铺:" required>
                    <div class="flexc">
                      <el-checkbox-group
                        v-model="ruleDto.venderIds"
                        @change="checkShopChange"
                      >
                        <el-checkbox
                          :label="item.venderId"
                          v-for="item in shopList"
                          :key="item.venderId"
                          :disabled="
                            item.venderId == venderId || activityData.isStart
                          "
                          >{{ item.shopTitle }}</el-checkbox
                        >
                        <el-tooltip effect="light" placement="top">
                          <template #content>
                            <div>1.当前店铺默认勾选，且不可取消勾选；</div>
                            <div>
                              2.仅展示当前账号有权限且为同一会员体系下的店铺；
                            </div>
                            <div>
                              3.多店情况下支持用户对活动范围内的店铺订单进行解锁。
                            </div>
                          </template>
                          <el-button type="text" style="width: 35px">
                            <i class="el-icon-question grey-color"></i>
                          </el-button>
                        </el-tooltip>
                      </el-checkbox-group>
                    </div>
                  </el-form-item>
                  <el-form-item label="下单时间:" required>
                    <div class="my_select_time">
                      <el-date-picker
                        prefix-icon="no_icon"
                        v-model="ruleForm.orderStartTime"
                        type="datetime"
                        placeholder="开始日期"
                        size="small"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        style="width: 190px; font-size: 12px"
                        default-time="00:00:00"
                        class="time1"
                        @change="orderChange"
                        @focus="orderFocus(2)"
                        :clearable="false"
                        :picker-options="pickerOrderStart"
                      >
                      </el-date-picker>
                      <div class="time_to_text">至</div>
                      <el-date-picker
                        prefix-icon="no_icon"
                        v-model="ruleForm.orderEndTime"
                        type="datetime"
                        placeholder="结束日期"
                        size="small"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        style="width: 195px; font-size: 12px"
                        default-time="23:59:59"
                        class="time2"
                        @change="orderChange"
                        @focus="orderFocus(2)"
                        :clearable="false"
                        :picker-options="pickerOrderEnd"
                      >
                      </el-date-picker>
                      <i
                        v-if="!isStart"
                        class="el-icon-circle-close date_icon1"
                        @click="clearOrderTime()"
                      ></i>
                      <img
                        src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                        alt=""
                        class="date_icon2"
                      />
                    </div>
                    <el-tooltip
                      class="item"
                      effect="light"
                      content="订单验证时间不得超过100天"
                      placement="bottom"
                    >
                      <el-button type="text" style="width: 35px">
                        <i class="el-icon-question" style="color: #ccc"></i>
                      </el-button>
                    </el-tooltip>
                    <div class="act-tip" v-if="isShowTip">
                      *提示：修改下单时间活动条件不会改变已参与用户的数据状态，修改仅适用于新用户参与活动的判定
                    </div>
                  </el-form-item>
                  <el-form-item label="金额统计类型:" required>
                    <el-radio-group
                      v-model="ruleForm.popOrderStartPaymentType"
                      :disabled="activityData.isStart"
                    >
                      <el-radio :label="1">
                        <span>订单金额（后台价）</span>
                        <el-tooltip class="item" effect="dark" content="是指京东后台价，不等于商城前台页面展示的价格，前台页面无法查看该后台价格；如需查询后台价格，请联系采销核实。" placement="top-start">
                          <div class="new-icon-box" style="margin: -3px 8px"></div>
                        </el-tooltip>
                      </el-radio>
                      <el-radio :label="0" v-if="selectShopsType==2">
                        <span>用户应付金额</span>
                        <el-tooltip class="item" effect="dark" content="订单商品原价总额-订单优惠总额+订单运费+税费+调整运费金额=用户应付金额" placement="top-start">
                          <div class="new-icon-box" style="margin: -3px 8px"></div>
                        </el-tooltip>
                      </el-radio>
                      <el-radio :label="2" v-if="selectShopsType==2">
                        <span>用户实付金额</span>
                        <el-tooltip class="item" effect="dark" content="用户应付金额-支付优惠总额=用户实付金额" placement="top-start">
                          <div class="new-icon-box" style="margin: -3px 8px"></div>
                        </el-tooltip>
                      </el-radio>
                    </el-radio-group>
                    <div class="memberTips" style="margin-right: 30px">
                      注意：由于接口原因，自营仅支持统计订单金额，pop可按需选择统计实付金额或订单金额。
                    </div>
                  </el-form-item>
                  <el-form-item label="指定购买商品:" required v-if="!isNongfu">
                    <el-radio
                      v-model="ruleForm.filterType"
                      @change="filterTypeChange"
                      label="0"
                      :disabled="isStart"
                    >
                      全部商品
                    </el-radio>
                    <el-radio
                      v-model="ruleForm.filterType"
                      @change="filterTypeChange"
                      label="1"
                      :disabled="isStart"
                      >指定商品</el-radio
                    >
                    <el-radio
                      v-model="ruleForm.filterType"
                      @change="filterTypeChange"
                      label="2"
                      :disabled="isStart"
                      >排除商品</el-radio
                    >
                    <jd-button
                      :disabled="ruleForm.filterType == 0 || isStart"
                      v-if="ruleDto.venderIds.length == 1"
                      @click="orderSelectGoods(venderId)"
                    >
                      {{
                        ruleDto.sellerSkuList.length
                          ? `已选择(${ruleDto.sellerSkuList[0] && ruleDto.sellerSkuList[0].skuIds.length || 0}个)`
                          : "+添加"
                      }}
                    </jd-button>
                    <div v-else-if="ruleDto.venderIds.length > 1 && ruleForm.filterType != 0">
                      <div v-for="item in ruleDto.sellerSkuList" :key="item.venderId">
                        <div class="flexc-cen-x mb8">
                          <div class="shoptitle-label">{{getTitle(item.venderId)}}</div>
                          <jd-button @click="orderSelectGoods(item.venderId)" v-loading="skuIdListLoading"
                            :disabled="activityData.isStart">
                            已选择
                            {{item.skuIds.length }}个
                          </jd-button>
                        </div>
                      </div>
                    </div>
                  </el-form-item>
                  <el-form-item label="指定商品规则:" v-if="ruleForm.popOrderStartPaymentType==1&&activityData.id ==18&&ruleForm.filterType=='1'">
                    <el-select  
                      v-model="ruleDto.filterSkuType" :disabled="activityData.isStart"
                      placeholder="请选择" style="width: 270px;">
                      <el-option
                        label="只要订单包含指定商品就整单计算"
                        :value="0"
                      >
                      </el-option>
                      <el-option
                        label="仅统计订单内指定商品的金额和件数"
                        :value="1"
                      >
                      </el-option>
                    </el-select>
                    <jd-button type="blueText" class="ml12" @click="viewStatisticsLogic">查看统计逻辑</jd-button>
                  </el-form-item>
                  <template v-if="!isNongfu && ruleForm.prizeSettingType == 0">
                    <el-form-item label="订单金额:" required>
                      大于等于
                      <el-input
                        v-model="ruleForm.orderStartPayment"
                        @input="
                          ruleForm.orderStartPayment = setNumber(
                            $event,
                            1,
                            true
                          )
                        "
                        @change="changDays()"
                        style="width: 140px"
                        placeholder="请输入"
                        :disabled="isStart"
                      ></el-input>
                      &nbsp; 元 &nbsp;
                      <!-- <span style="color:red;margin-left:0px">注意：由于接口原因，pop支持统计实付金额，自营仅支持统计订单金额。</span> -->
                    </el-form-item>
                    <el-form-item label="商品件数:" width="">
                      大于等于
                      <el-input
                        v-model="ruleForm.orderStartCount"
                        @input="
                          ruleForm.orderStartCount = setNumber($event, 1, true)
                        "
                        @change="changDays()"
                        style="width: 140px"
                        placeholder="请输入"
                        :disabled="isStart"
                      ></el-input>
                      &nbsp; 件 &nbsp;
                    </el-form-item>
                  </template>
                  <el-form-item label="订单拆单后是否合并:" label-width="160px" required>
                    <el-radio-group
                      :disabled="activityData.isStart"
                      v-model="ruleForm.mergeOrder"
                    >
                      <el-radio :label="false">否</el-radio>
                      <el-radio :label="true">是</el-radio>
                    </el-radio-group>
                    <jd-button type="blueText" class="ml12" @click="viewMergeLogic">查看合并拆单逻辑</jd-button>
                  </el-form-item>
                  <el-form-item label="C端选择订单号:">
                    <div class="support">
                      <el-checkbox
                        v-model="ruleForm.isSupportOrderList"
                        :disabled="isStart"
                        :false-label="0"
                        :true-label="1"
                      ></el-checkbox>
                      <span class="support-text"
                        >用户参与活动时支持选择订单号，无需手动输入</span
                      >
                      <el-popover placement="top-start" trigger="hover">
                        <i
                          slot="reference"
                          class="el-icon-question support-icon"
                        ></i>
                        <div>
                          <img
                            src="https://s3.cn-north-1.jdcloud-oss.com/yeion-public/hd/images/orderList_preview.png"
                            alt=""
                          />
                        </div>
                      </el-popover>
                    </div>
                  </el-form-item>
                </div>
              </div>
              <div class="rule_prize" v-if="ruleForm.prizeSettingType == 0">
                <jd-table
                  :tableData="tableData"
                  class="tableData"
                  style="width: 100%"
                >
                  <el-table-column prop="date" label="序号" width="110">
                    <template slot-scope="scope">
                      <span>{{ scope.$index + 1 }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="奖品类型">
                    <template slot-scope="scope">
                      <div>
                        <jd-button
                          type="blueText"
                          :disabled="activityData.isStart || backgroundOpacity"
                          @click="centerVis(scope)"
                        >
                          <div v-if="scope.row.prizeType">
                            <span v-if="scope.row.prizeType == 3">
                              {{ scope.row.title }}
                            </span>
                            <span v-else>
                              {{ scope.row.prizeType | prizeType(venderType) }}
                            </span>
                          </div>
                          <div v-else>
                            <span>选奖品</span>
                          </div>
                        </jd-button>
                      </div>
                    </template>
                  </el-table-column>

                  <el-table-column label="值" width="80" prop="price">
                  </el-table-column>

                  <el-table-column label="奖品总份数" width="180">
                    <template slot-scope="scope">
                      <el-input
                        v-model.number="scope.row.prizeCount"
                        @input.native="
                          (e) =>
                            (scope.row.prizeCount = checkputn(
                              e,
                              scope.row,
                              'jindou'
                            ))
                        "
                        placeholder="请输入..."
                        @input="
                          (scope.row.prizeCount = getNumberData(
                            1,
                            $event,
                            0,
                            1
                          )),
                            prizeNum(scope.row)
                        "
                        @blur="beAdd(scope.row)"
                        :disabled="backgroundOpacity || activityData.isStart"
                      ></el-input>
                      <!-- <div
                        class="del_box2"
                        v-if="!isStart && tableData.length > 1"
                      >
                        <div class="delQx" @click="itemDelTable(scope.$index)">
                          <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/btn_del.svg" alt="" />
                        </div>
                      </div> -->
                    </template>
                  </el-table-column>
                  <el-table-column label="每日发放限额" width="120">
                    <template slot-scope="scope">
                      <dailyLimitConfig
                        :row="scope.row"
                        :backgroundOpacity="backgroundOpacity"
                        :limitBtnDisabled="backgroundOpacity"
                        totalAmountKey="prizeCount"
                      ></dailyLimitConfig>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button
                        type="text"
                        v-if="scope.row.title && isStart"
                        @click="itemAddNum('tableData', scope.$index)"
                        >增加奖品数量</el-button
                      >
                      <el-button
                        type="text"
                        v-if="!isStart"
                        @click="itemDelTable(scope.$index)"
                        >删除</el-button
                      >
                    </template>
                  </el-table-column>
                </jd-table>
                <jd-button
                  style="margin-top: 15px"
                  @click="addPrizeRule"
                  v-if="!isStart"
                >
                  添加奖项（{{ tableData.length }}/4）
                </jd-button>
              </div>
              <div class="rule_prize" v-else>
                <jd-table
                  :tableData="ladderData"
                  class="tableData"
                  key="ladderData"
                >
                  <el-table-column prop="date" label="阶梯" width="110">
                    <template slot-scope="scope">
                      <span>{{ scope.$index + 1 }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column width="200" label="消费金额">
                    <template slot-scope="scope">
                      <span>大于等于</span>
                      <el-input
                        v-model="scope.row.orderAmtLimit"
                        placeholder="请输入"
                        style="width: 100px"
                        :disabled="isStart"
                        @input="
                          scope.row.orderAmtLimit = getNumberData(
                            1,
                            $event,
                            1,
                            0
                          )
                        "
                      ></el-input
                      >元
                    </template>
                  </el-table-column>
                  <el-table-column width="200" label="商品件数">
                    <template slot-scope="scope">
                      且满
                      <el-input
                        v-model="scope.row.itemTotalLimit"
                        placeholder="请输入"
                        style="width: 100px"
                        :disabled="isStart"
                        @input="
                          scope.row.itemTotalLimit = getNumberData(
                            1,
                            $event,
                            0,
                            1
                          )
                        "
                      ></el-input>
                      件
                    </template>
                  </el-table-column>
                  <el-table-column prop="name" label="奖品类型">
                    <template slot-scope="scope">
                      <span
                        style="color: #2768ff; cursor: pointer"
                        v-if="scope.row.prizeType == 3"
                        @click="centerVis2(scope)"
                        >{{ scope.row.title }}</span
                      >
                      <span
                        style="color: #2768ff; cursor: pointer"
                        v-else-if="scope.row.prizeType"
                        @click="centerVis2(scope)"
                        >{{ scope.row.prizeType | prizeType(venderType) }}</span
                      >
                      <span
                        v-else
                        @click="centerVis2(scope)"
                        style="color: #2768ff; cursor: pointer"
                        >选择奖品</span
                      >
                    </template>
                  </el-table-column>
                  <el-table-column prop="price" width="110" label="值">
                  </el-table-column>
                  <el-table-column width="145" label="奖品总份数">
                    <template slot-scope="scope">
                      <el-input
                        v-model="scope.row.prizeCount"
                        placeholder="请输入"
                        @input.native="
                          (e) =>
                            (scope.row.prizeCount = checkputn(
                              e,
                              scope.row,
                              'jindou'
                            ))
                        "
                        @input="
                          (scope.row.prizeCount = getNumberData(
                            1,
                            $event,
                            0,
                            1
                          )),
                            prizeNum(scope.row)
                        "
                        @blur="beAdd(scope.row)"
                        :disabled="
                          (activityData.isStart && !scope.row.minNum) || isStart
                        "
                      ></el-input>
                      <!-- <div class="del_box1" v-if="!isStart">
                        <div class="delQx" @click="itemDelLadder(scope.$index)">
                          <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/btn_del.svg" alt="" />
                        </div>
                      </div> -->
                    </template>
                  </el-table-column>
                  <el-table-column label="每日发放限额" width="120">
                    <template slot-scope="scope">
                      <dailyLimitConfig
                        :row="scope.row"
                        :backgroundOpacity="backgroundOpacity"
                        :limitBtnDisabled="backgroundOpacity"
                        totalAmountKey="prizeCount"
                      ></dailyLimitConfig>
                    </template>
                  </el-table-column>
                  <el-table-column label="操作">
                    <template slot-scope="scope">
                      <el-button
                        type="text"
                        v-if="scope.row.title && isStart"
                        @click="itemAddNum('ladderData', scope.$index)"
                        >增加奖品数量</el-button
                      >
                      <el-button
                        type="text"
                        v-if="!isStart"
                        @click="itemDelLadder(scope.$index)"
                        >删除</el-button
                      >
                    </template>
                  </el-table-column>
                </jd-table>
                <jd-button
                  style="margin-top: 15px"
                  @click="addLadderRule"
                  v-if="!isStart"
                >
                  添加阶梯（{{ ladderData.length }}/4）
                </jd-button>
              </div>
            </el-form-item>
            <jd-title
              label="奖品设置"
              type="bold"
              v-if="activityData.id != 18"
            />
            <el-form-item
              label="奖品设置:"
              required
              v-if="activityData.id != 18"
            >
              <span
                >{{ activityData.id == 17 ? "整个活动期内每人只可领取1次及其中1个奖品" : "订单完成后发放奖励,整个活动期内每人只可领取1次及其中1个奖品。" }}</span
              >
              <div style="margin: 10px 46px" v-if="activityData.id == 16">
                <el-radio-group
                  v-model="ruleForm.prizeSettingType"
                  :disabled="isStart"
                >
                  <el-radio :label="0">统一奖品</el-radio>
                  <el-radio :label="1">阶梯奖品</el-radio>
                </el-radio-group>
              </div>
              
            <!-- 首购专享礼奖品发放形式 -->
            <el-form-item
              label="奖品发放形式:"
              required
              style="margin-left: -120px;"
              v-if="activityData.id == 17">
              <template v-if="activityData.id == 17">
                 <div style="display: flex;align-items: center;">
                   <el-radio v-model="ruleDto.sendType" :label="0" :disabled="activityData.isStart">立即发放</el-radio>
                   <el-radio @change="ruleDto.sendDay= ''" v-model="ruleDto.sendType" :label="1" :disabled="activityData.isStart">确认收货
                     <el-input
                       v-if="ruleDto.sendType == 1"
                       v-model="ruleDto.sendDay" :disabled="activityData.isStart" placeholder="请输入天数"
                       @input="(e) => (ruleDto.sendDay = validSe(e))"
                       style="width: 80px;margin: 0 4px;"></el-input>
                       <el-input :disabled="true" style="width: 80px;margin: 0 4px;" v-else></el-input>
                       天后发放</el-radio>
                   <el-radio @change="ruleDto.sendDay= ''" v-model="ruleDto.sendType" :label="2" :disabled="activityData.isStart">活动结束
                     <el-input
                       v-if="ruleDto.sendType == 2"
                       v-model="ruleDto.sendDay" :disabled="activityData.isStart" placeholder="请输入天数"
                       @input="(e) => (ruleDto.sendDay = validSe(e))"
                       style="width: 80px;margin: 0 4px;"></el-input>
                       <el-input :disabled="true" style="width: 80px;margin: 0 4px;" v-else></el-input>
                       天后发放</el-radio>
                   <el-tooltip placement="top-start" effect="dark">
                     <div slot="content">
                       1.立即发放:用户下单符合条件后，系统立即发放奖品;<br />
                       2.确认收货后发放:用户确认收货满XX天后，商家需自行发货;<br />
                       3.活动结束后发放:活动结束X天后，商家需自行发货;<br />
                     </div>
                     <div>
                       发放规则<i class="el-icon-question"></i>
                     </div>
                   </el-tooltip>
                 </div>
                </template>
              </el-form-item>
            
              <template v-if="ruleForm.prizeSettingType == 0">
                <div class="rule_box_bottom" v-if="isNongfu">
                  <div class="condition">条件一 :</div>
                </div>
                <div class="rule_box_bottom">
                  <template v-if="isNongfu">
                    <el-form-item label="商品件数:" required>
                      <el-input
                        v-model="ruleForm.orderStartCount"
                        @input="
                          ruleForm.orderStartCount = getNumberData(
                            1,
                            $event,
                            0,
                            1
                          )
                        "
                        @change="changDays()"
                        style="width: 140px"
                        placeholder="请输入"
                        :disabled="isStart"
                      ></el-input
                      >&nbsp; 件- &nbsp;
                      <el-input
                        v-model="ruleForm.orderEndCount"
                        @input="
                          ruleForm.orderEndCount = getNumberData(
                            1,
                            $event,
                            0,
                            1
                          )
                        "
                        @change="changDays()"
                        style="width: 140px"
                        placeholder="请输入"
                        :disabled="isStart"
                      ></el-input
                      >&nbsp; 件
                    </el-form-item>
                    <el-form-item label="订单金额:" required>
                      <el-input
                        v-model="ruleForm.orderStartPayment"
                        @input="
                          ruleForm.orderStartPayment = getNumberData(
                            1,
                            $event,
                            1,
                            0
                          )
                        "
                        @change="changDays()"
                        style="width: 140px"
                        placeholder="请输入"
                        :disabled="isStart"
                      ></el-input
                      >&nbsp; 元- &nbsp;
                      <el-input
                        v-model="ruleForm.orderEndPayment"
                        @input="
                          ruleForm.orderEndPayment = getNumberData(
                            1,
                            $event,
                            1,
                            0
                          )
                        "
                        @change="changDays()"
                        style="width: 140px"
                        placeholder="请输入"
                        :disabled="isStart"
                      ></el-input
                      >&nbsp; 元<br />
                      <!-- <span style="color:red;margin-left:0px"
                        >注意：由于接口原因，pop支持统计实付金额，自营仅支持统计订单金额。</span
                      > -->
                    </el-form-item>
                    <el-form-item
                      label="指定购买商品:"
                      required
                      v-if="isNongfu"
                    >
                      <el-radio
                        v-model="ruleForm.filterType"
                        @change="filterTypeChange"
                        label="0"
                        :disabled="isStart"
                      >
                        全部商品
                      </el-radio>
                      <el-radio
                        v-model="ruleForm.filterType"
                        @change="filterTypeChange"
                        label="1"
                        :disabled="isStart"
                        >指定商品</el-radio
                      >
                      <jd-button
                        :disabled="ruleForm.filterType == 0 || isStart"
                        @click="exposureProductsFiter"
                      >
                        {{
                          itemListForFilter.length != ""
                            ? "已选择" + "(" + itemListForFilter.length + "个)"
                            : "+添加"
                        }}
                      </jd-button>
                    </el-form-item>
                  </template>
                </div>
                <div class="rule_box_bottom" v-if="isNongfu">
                  <div class="condition">条件二 :</div>
                </div>
                <div class="rule_box_bottom" v-if="isNongfu">
                  <el-form-item label=" ">
                    <el-checkbox
                      v-model="ruleForm.isLimitSkuAmt"
                      @change="testParmasSwitchChange"
                      :disabled="isStart"
                    >
                      是否指定商品金额
                    </el-checkbox>
                  </el-form-item>
                  <el-form-item label="指定商品:" required>
                    <el-button
                      type="primary"
                      :disabled="!ruleForm.isLimitSkuAmt || isStart"
                      @click="appointProductsFiter"
                      >选择商品</el-button
                    >
                  </el-form-item>
                  <el-form-item label="指定商品金额:" required>
                    <el-input
                      v-model="ruleForm.skuStartPayment"
                      @input="
                        ruleForm.skuStartPayment = getNumberData(
                          1,
                          $event,
                          1,
                          0
                        )
                      "
                      @change="skuPaymentChange()"
                      style="width: 140px"
                      placeholder="请输入"
                      :disabled="!ruleForm.isLimitSkuAmt || isStart"
                    ></el-input
                    >&nbsp; 元- &nbsp;
                    <el-input
                      v-model="ruleForm.skuEndPayment"
                      @input="
                        ruleForm.skuEndPayment = getNumberData(1, $event, 1, 0)
                      "
                      @change="skuPaymentChange()"
                      style="width: 140px"
                      placeholder="请输入"
                      :disabled="!ruleForm.isLimitSkuAmt || isStart"
                    ></el-input
                    >&nbsp; 元<br />
                    <!-- <span style="color:red;margin-left:0px"
                      >注意：由于接口原因，pop支持统计实付金额，自营仅支持统计订单金额。</span
                    > -->
                  </el-form-item>
                </div>
                <div class="prize_box">
                  <jd-table
                    :tableData="tableData"
                    class="tableData"
                    key="tableData"
                    style="width: 825px;"
                  >
                    <el-table-column prop="date" label="序号" width="110">
                      <template slot-scope="scope">
                        <!-- <el-input @keyup.native="limitInput($event)" v-model="scope.row.peopleCount"></el-input> -->
                        <span>{{ scope.$index + 1 }}</span>
                      </template>
                    </el-table-column>
                    <el-table-column prop="name" label="奖品类型">
                      <template slot-scope="scope">
                        <span
                          style="color: #2768ff; cursor: pointer"
                          v-if="scope.row.prizeType == 3"
                          @click="centerVis(scope)"
                          >{{ scope.row.title }}</span
                        >
                        <span
                          style="color: #2768ff; cursor: pointer"
                          v-else-if="scope.row.prizeType"
                          @click="centerVis(scope)"
                          >{{ scope.row.prizeType | prizeType(venderType)  }}</span
                        >
                        <span
                          v-else
                          @click="centerVis(scope)"
                          style="color: #2768ff; cursor: pointer"
                          >选择奖品</span
                        >
                      </template>
                    </el-table-column>
                    <el-table-column prop="price" width="110" label="值">
                    </el-table-column>
                    <el-table-column width="145" label="奖品总份数">
                      <template slot-scope="scope">
                        <el-input
                          v-model="scope.row.prizeCount"
                          placeholder="请输入"
                          @input.native="
                            (e) =>
                              (scope.row.prizeCount = checkputn(
                                e,
                                scope.row,
                                'jindou'
                              ))
                          "
                          @input="
                            (scope.row.prizeCount = getNumberData(
                              1,
                              $event,
                              0,
                              1
                            )),
                              prizeNum(scope.row)
                          "
                          @blur="beAdd(scope.row)"
                          :disabled="
                            (activityData.isStart && !scope.row.minNum) ||
                            isStart
                          "
                        ></el-input>
                        <!-- <div class="del_box" v-if="!isStart">
                          <div class="delQx" @click="itemDel(scope.$index)">
                            <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/btn_del.svg" alt="" />
                          </div>
                        </div> -->
                      </template>
                    </el-table-column>
                    <el-table-column label="每日发放限额" width="120">
                      <template slot-scope="scope">
                        <dailyLimitConfig
                          :row="scope.row"
                          :backgroundOpacity="backgroundOpacity"
                          :limitBtnDisabled="backgroundOpacity"
                          totalAmountKey="prizeCount"
                        ></dailyLimitConfig>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作">
                      <template slot-scope="scope">
                        <jd-button
                          type="blueText"
                          v-if="scope.row.title && isStart"
                          @click="itemAddNum('tableData', scope.$index)"
                          >增加奖品数量</jd-button
                        >
                        <jd-button
                          type="blueText"
                          v-if="!isStart"
                          @click="itemDel(scope.$index)"
                          >删除</jd-button
                        >
                      </template>
                    </el-table-column>
                  </jd-table>
                  <jd-button
                    style="margin-top: 15px"
                    @click="addPrizeRule"
                    v-if="!isStart"
                  >
                    添加奖项（{{ tableData.length }}/4）
                  </jd-button>
                </div>
              </template>
              <template
                v-if="ruleForm.prizeSettingType == 1 && activityData.id == 16"
              >
                <div>
                  <span style="color: red"
                    >注意：当满足多个阶梯条件时，可任选其中一个奖品，但只能领取1次奖品。</span
                  >
                </div>

                <span>阶梯条件显示：</span>
                <el-radio-group
                  v-model="ladder.prizeShowType"
                  :disabled="isStart"
                >
                  <el-radio :label="0"
                    >显示（C端小程序奖品上方会分别显示对应的阶梯条件）</el-radio
                  >
                  <el-radio :label="1">不显示</el-radio>
                </el-radio-group>
                <div>
                  <span>门槛统计：</span>
                  <el-select
                    v-model="ladder.orderCountType"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in thresholdList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="prize_box">
                  <jd-table
                    :tableData="ladderData"
                    key="ladderData"
                    class="tableData"
                    style="width: 1100px;"
                  >
                    <el-table-column width="200" label="消费金额门槛">
                      <template slot-scope="scope">
                        <el-input
                          v-model="scope.row.orderAmtLimit"
                          placeholder="请输入"
                          style="width: 100px"
                          :disabled="isStart"
                          @input="
                            scope.row.orderAmtLimit = getNumberData(
                              1,
                              $event,
                              1,
                              0
                            )
                          "
                        ></el-input>
                        元
                      </template>
                    </el-table-column>
                    <el-table-column width="200" label="商品件数门槛">
                      <template slot-scope="scope">
                        且满
                        <el-input
                          v-model="scope.row.itemTotalLimit"
                          placeholder="请输入"
                          style="width: 100px"
                          :disabled="isStart"
                          @input="
                            scope.row.itemTotalLimit = getNumberData(
                              1,
                              $event,
                              0,
                              1
                            )
                          "
                        ></el-input>
                        件
                      </template>
                    </el-table-column>
                    <el-table-column prop="name" label="奖品类型">
                      <template slot-scope="scope">
                        <span
                          style="color: #2768ff; cursor: pointer"
                          v-if="scope.row.prizeType == 3"
                          @click="centerVis2(scope)"
                          >{{ scope.row.title }}</span
                        >
                        <span
                          style="color: #2768ff; cursor: pointer"
                          v-else-if="scope.row.prizeType"
                          @click="centerVis2(scope)"
                          >{{ scope.row.prizeType | prizeType(venderType)  }}</span
                        >
                        <span
                          v-else
                          @click="centerVis2(scope)"
                          style="color: #2768ff; cursor: pointer"
                          >选择奖品</span
                        >
                      </template>
                    </el-table-column>
                    <el-table-column prop="price" width="110" label="值">
                    </el-table-column>
                    <el-table-column width="145" label="奖品总份数">
                      <template slot-scope="scope">
                        <el-input
                          v-model="scope.row.prizeCount"
                          placeholder="请输入"
                          @input.native="
                            (e) =>
                              (scope.row.prizeCount = checkputn(
                                e,
                                scope.row,
                                'jindou'
                              ))
                          "
                          @input="
                            (scope.row.prizeCount = getNumberData(
                              1,
                              $event,
                              0,
                              1
                            )),
                              prizeNum(scope.row)
                          "
                          @blur="beAdd(scope.row)"
                          :disabled="
                            (activityData.isStart && !scope.row.minNum) ||
                            isStart
                          "
                        ></el-input>
                        <!-- <div class="del_box" v-if="!isStart">
                          <div
                            class="delQx"
                            @click="itemDelLadder(scope.$index)"
                          >
                            <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/btn_del.svg" alt="" />
                          </div>
                        </div> -->
                      </template>
                    </el-table-column>
                    <el-table-column label="每日发放限额" width="120">
                      <template slot-scope="scope">
                        <dailyLimitConfig
                          :row="scope.row"
                          :backgroundOpacity="backgroundOpacity"
                          :limitBtnDisabled="backgroundOpacity"
                          totalAmountKey="prizeCount"
                        ></dailyLimitConfig>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作">
                      <template slot-scope="scope">
                        <jd-button
                          type="blueText"
                          v-if="scope.row.title && isStart"
                          @click="itemAddNum('ladderData', scope.$index)"
                          >增加奖品数量</jd-button
                        >
                        <jd-button
                          type="blueText"
                          v-if="!isStart"
                          @click="itemDelLadder(scope.$index)"
                          >删除</jd-button
                        >
                      </template>
                    </el-table-column>
                  </jd-table>
                  <jd-button
                    style="margin-top: 15px"
                    @click="addLadderRule"
                    v-if="!isStart"
                  >
                    增加阶梯（{{ ladderData.length }}/4）
                  </jd-button>
                </div>
              </template>
            </el-form-item>

            <!-- <el-form-item
              label="锁定奖品:"
              required
              v-if="activityData.id == 17"
            >
              <el-radio-group v-model="ruleForm.lockPrizeType" :disabled="activityData.isStart">
                <el-radio :label="0">达成条件领取奖品</el-radio>
                <el-radio :label="1">完成付款锁定奖品</el-radio>
              </el-radio-group>
              <el-input v-model.number="ruleForm.lockPrizeDay" class="lock-input" @input="ruleForm.lockPrizeDay = getNumberData(1,$event,0,0)" :disabled="ruleForm.lockPrizeType==0||activityData.isStart" placeholder="请输入"></el-input>日
              <el-tooltip
                class="item"
                effect="light"
                trigger="hover"
                placement="right"
              >
                <div slot="content">
                  <div>
                    1、达成条件领取奖品：需用户达成订单条件且订单状态已完成才可进入活动页领取奖品；
                  </div>
                  <div>
                    2、完成付款锁定奖品：用户达成订单条件且已付款后，可进行锁定奖品X日，到指定日期用户达成完成订单条件奖品自动发放；（期间取消订单即发放失败，回归奖品库存）
                  </div>
                </div>
                <i
                  class="el-icon-question tip-icon"
                ></i>
              </el-tooltip>
            </el-form-item>

            <el-form-item
              label="是否支持订单取消后可重新绑定其他订单领取奖品:"
              required
              v-if="activityData.id == 17"
              label-width="340px"
            >
              <el-radio-group v-model="ruleForm.supportCancelOrderRebind" :disabled="activityData.isStart">
                <el-radio :label="1">支持重新绑定领取</el-radio>
                <el-radio :label="0">不支持重新绑定领取</el-radio>
              </el-radio-group>
            </el-form-item> -->

            <el-form-item
              label="是否支持C端撤回奖品:"
              required
              label-width="180px"
            >
              <el-radio-group
                v-model="ruleForm.supportRollback"
                :disabled="isStart"
              >
                <el-radio :label="1">支持撤回</el-radio>
                <el-radio :label="0">不支持撤回</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              v-if="activityData.id == 16"
              label="领取实物奖品后取消订单重新下单可重新领取奖品:"
              required
              label-width="350px"
            >
              <el-radio-group
                v-model="ruleForm.supportCancelOrderRebind"
                :disabled="isStart"
              >
                <el-radio :label="1">支持撤回</el-radio>
                <el-radio :label="0">不支持撤回</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="是否支持订单取消后可重新绑定其他订单领取奖品:"
              required
              v-if="activityData.id == 18"
              label-width="340px"
            >
              <el-radio-group v-model="ruleForm.supportCancelOrderRebind" :disabled="activityData.isStart">
                <el-radio :label="0">不支持重新绑定领取</el-radio>
                <el-radio :label="1">支持重新绑定领取</el-radio>
              </el-radio-group>
            </el-form-item>
            <jd-title label="进店设置" type="bold"></jd-title>
            <el-form-item label="进店逛逛:">
              <el-radio-group
                v-model="ruleForm.goShopSetting"
                :disabled="isStart"
                @change="onShopSetChange"
              >
                <el-radio :label="0">进入店铺首页</el-radio>
                <el-radio :label="1">跳转指定小程序</el-radio>
                <el-radio :label="2">进入指定链接</el-radio>
              </el-radio-group>
              <div style="color: #f56c6c">
                部分活动需要配合曝光商品使用，如幸运抽奖、裂变神券
              </div>
            </el-form-item>
            <div v-if="ruleForm.goShopSetting == 1">
              <el-form-item label="小程序appId:" required>
                <el-input
                  type="textarea"
                  placeholder="请输入小程序appId"
                  style="width: 425px; margin-left: 8px"
                  show-word-limit
                  v-model="ruleForm.goShopAppId"
                  :maxlength="1000"
                  :disabled="isStart"
                ></el-input>
              </el-form-item>
              <el-form-item label="页面路径path:">
                <el-input
                  type="textarea"
                  placeholder="请输入小程序页面路径path"
                  style="width: 425px; margin-left: 8px"
                  show-word-limit
                  v-model="ruleForm.goShopUrl"
                  :maxlength="1000"
                  :disabled="isStart"
                ></el-input>
                <div style="color: #f56c6c">
                  注意：path若不写，则默认进入小程序主页。
                </div>
              </el-form-item>
            </div>
            <el-form-item
              label="指定链接:"
              required
              v-if="ruleForm.goShopSetting == 2"
            >
              <el-input
                type="textarea"
                placeholder="请输入指定链接"
                style="width: 425px; margin-left: 8px"
                show-word-limit
                v-model="ruleForm.goShopUrl"
                :maxlength="1000"
                :disabled="isStart"
              ></el-input>
              <div style="color: #f56c6c">
                注意：仅可填写京东域内的
                H5页面地址，不可设置外链。参考链接：https://m.jd.com/。
              </div>
            </el-form-item>
            <activityPageSettings 
            :cusTemplateJSON.sync="cusTemplateJSON"
            v-model="customerPaperwork" 
            :isNeedSetBG="true" 
            :isNeedCustomerPaperworkData="ruleForm.paperworkType == 1" 
            :giftList="giftList" 
            :templateId="templateId" 
            @selectTemplate="selectTemplate" 
            :widthNumber="750" 
            :heightNumber="1604" 
            :templatekey="'imageUrl'"
            :defaultRgb="rgb3"
            :isCustomPreview="true"
            :designSpecificationsUrl="designSpecificationsList[activityData.id]"
            :isShowShopName="true"
            isShowMoreSet
            >
              <template #otherSetHead>
                  <el-form-item label="活动模板文案:" required>
                  <el-radio-group
                    v-model="ruleForm.paperworkType"
                  >
                    <el-radio :label="0">系统默认文案</el-radio>
                    <el-radio :label="1">自定义文案</el-radio>
                  </el-radio-group>
                </el-form-item>
              </template>
              <template #otherSetMiddle>
                <el-form-item v-if="ruleForm.paperworkType == 1" label="说明文字颜色:">
                    <div style="display: flex;align-items: center;">
                      <el-color-picker
                        v-model="customerPaperwork.descColor"
                        class="colorPicker"
                      >
                      </el-color-picker>
                      <jd-button
                        type="blueText"
                        style="margin-left: 20px"
                        @click="customerPaperwork.descColor = rgb2"
                        >重置</jd-button
                      >
                    </div>
                  </el-form-item>
              </template>
              <template #customPreview>
                <div style="margin-top: -100px;">
                  <preview-bg
                  ref="updateRef"
                  :ruleForm="customerPaperwork"
                  :prizeSetting="newPrizeSetting"
                  :prizeSettingType="ruleForm.prizeSettingType"
                  :rgb="rgb"
                  :actType="activityData.id"
                  :yAxis="yAxis"
                  :bgUrl="newPreviewUrl"
                  :paperworkType="ruleForm.paperworkType"
                  :ladder="ladder"
                  />
              </div>
              </template>
            </activityPageSettings>
            <exposureList 
              :defaultExposureSwitch.sync="ruleForm.exposureSwitch" 
              v-model="itemListFor" 
              :isEdit="activeValue ? true : false"
              :backgroundOpacity="backgroundOpacity"
              :multiShopGoods="multiShopGoods"
              :skuBelongVenderId="ruleDto.skuBelongVenderId"
              :multiShopSkuType.sync="ruleDto.multiShopSkuType"
              isLimit
            ></exposureList>
            <sharFrom :sharePic="sharePic" v-model="ruleForm"></sharFrom>
            <activityRules :valueRow="valueRow" :activityData="activityData" :isForceRemind.sync="isForceRemind" :isKeyActivity.sync="isKeyActivity"
            :placementPosition.sync="placementPosition" v-model="ruleForm.activityRulesText" @generateRule="generateRule"></activityRules>
            <!-- <div class="flex-jc">
              <div>
                <jd-title label="活动页设置" type="bold"></jd-title>
                <el-form-item label="活动模板文案:" required>
                  <el-radio-group
                    v-model="ruleForm.paperworkType"
                    :disabled="isStart"
                  >
                    <el-radio :label="0">系统默认文案</el-radio>
                    <el-radio :label="1">自定义文案</el-radio>
                  </el-radio-group>
                </el-form-item>
                <div v-if="ruleForm.paperworkType == 1">
                  <el-form-item label="活动标题:" required>
                    <el-input
                      placeholder="请输入活动标题"
                      style="width: 425px; margin-left: 8px"
                      show-word-limit
                      v-model="customerPaperwork.title"
                      :maxlength="10"
                      :disabled="isStart"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="活动说明:">
                    <el-input
                      placeholder="请输入活动说明"
                      style="width: 425px; margin-left: 8px"
                      show-word-limit
                      v-model="customerPaperwork.desc"
                      :maxlength="25"
                      :disabled="isStart"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="标题文字颜色:">
                    <div class="flex">
                      <el-color-picker
                        v-model="customerPaperwork.titleColor"
                        class="colorPicker"
                        :disabled="isStart"
                      >
                      </el-color-picker>
                      <jd-button
                        type="blueText"
                        style="margin-left: 20px"
                        :disabled="isStart"
                        @click="customerPaperwork.titleColor = rgb3"
                        >重置</jd-button
                      >
                    </div>
                  </el-form-item>
                  <el-form-item label="说明文字颜色:">
                    <div class="flex">
                      <el-color-picker
                        v-model="customerPaperwork.descColor"
                        :disabled="isStart"
                        class="colorPicker"
                      >
                      </el-color-picker>
                      <jd-button
                        type="blueText"
                        style="margin-left: 20px"
                        :disabled="isStart"
                        @click="customerPaperwork.descColor = rgb2"
                        >重置</jd-button
                      >
                    </div>
                  </el-form-item>
                </div>

                <jd-title label="曝光商品" type="bold" />
                <el-form-item label="曝光商品:" class="zindexBox">
                  <el-checkbox
                    v-model="ruleForm.exposureSwitch"
                    @change="exposureSwitchChange"
                  >
                    是否添加曝光商品
                  </el-checkbox>
                  <el-button
                    style="width: 155px; margin: 0 15px; display: inline-block"
                    :class="[
                      { add_btn1: ruleForm.exposureSwitch },
                      { 'global-view-btn': backgroundOpacity },
                    ]"
                    @click="exposureProducts"
                    :disabled="ruleForm.exposureSwitch == false"
                  >
                    {{
                      itemListFor.length != ""
                        ? "添加曝光商品" +
                          "(" +
                          itemListFor.length +
                          "/20" +
                          ")"
                        : "添加曝光商品"
                    }}
                  </el-button>
                  <el-radio-group
                    v-model="ruleForm.radio"
                    :disabled="ruleForm.exposureSwitch == false"
                  >
                    <el-radio :label="0">显示京东价</el-radio>
                  </el-radio-group>
                  <draggable
                    v-if="itemListFor.length > 0"
                    v-model="mainImagelist"
                    chosen-class="chosen"
                    :scroll="true"
                    animation="150"
                    force-fallback="true"
                    @start="isDragging = true"
                    @end="onEnd"
                    style="
                      margin-top: 10px;
                      background: rgba(38, 112, 251, 0.06);
                      padding: 10px;
                    "
                    filter=".unmover"
                  >
                    <transition-group type="transition">
                      <div
                        v-for="(item, index) in mainImagelist"
                        :key="item.skuId"
                        style="display: inline-block; position: relative"
                        class="show_upImg2"
                      >
                        <img
                          :src="item.logo"
                          width="120px"
                          height="120px"
                          style="display: inline-block"
                        />&nbsp;
                        <div class="delectPosible">
                          <span class="delectSort">拖动排序</span>
                          <img
                            src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/pages/delet.svg"
                            @click.stop="delec(index)"
                            class="delectIcom"
                          />
                        </div>
                      </div>
                    </transition-group>
                  </draggable>
                </el-form-item>
                <template>
                  <jd-title label="分享设置" type="bold"></jd-title>
                  <el-form-item
                    label="小程序分享标题:"
                    required
                    label-width="125"
                  >
                    <el-input
                      type="text"
                      style="width: 425px; margin-left: 8px"
                      show-word-limit
                      v-model="ruleForm.shareTitle"
                      :maxlength="28"
                      :disabled="isStart"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="小程序分享简介:"
                    required
                    label-width="125"
                  >
                    <el-input
                      type="text"
                      style="width: 425px; margin-left: 8px"
                      show-word-limit
                      v-model="ruleForm.shareIntroduce"
                      :maxlength="28"
                      :disabled="isStart"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="小程序分享图片:"
                    required
                    label-width="130"
                  >
                    <div class="miniAppPic" style="margin-left: 16px">
                      <div class="top">
                        <el-upload
                          class="upload"
                          action="/jd-hd-web/image/upload"
                          :show-file-list="false"
                          :before-upload="beforeUpload1"
                          :on-success="handleUpload1"
                          :disabled="isStart"
                        >
                          <jd-button type="blueText">自定义上传</jd-button>
                        </el-upload>
                        <jd-button
                          type="blueText"
                          style="margin-left: 20px"
                          @click="picUrlReset1"
                          >重置</jd-button
                        >
                      </div>
                      <div class="bottom">
                        <el-image
                          class="elImg"
                          :src="ruleForm.sharePic"
                          fit="contain"
                        >
                          <div slot="error" class="image-slot">
                            <i class="el-icon-plus"></i>
                          </div>
                        </el-image>
                        <div class="tips1">
                          <p>建议上传尺寸：200px * 200px</p>
                          <p>图片大小：1MB以内</p>
                          <p>格式：jpg、png</p>
                        </div>
                      </div>
                    </div>
                  </el-form-item>
                </template>
                <jd-title label="活动规则" type="bold"></jd-title>
                <el-form-item label="规则内容:" required>
                  <div
                    style="
                      width: 570px;
                      backgroundcolor: rgba(250, 250, 250, 1);
                      padding: 8px;
                      position: relative;
                    "
                  >
                    <el-input
                      type="textarea"
                      class="textarea"
                      style="width: 543px"
                      resize="none"
                      v-model="ruleForm.activityRulesText"
                      :maxlength="2000"
                    ></el-input>
                    <div class="prosi" style="color: #909399">
                      （{{
                        ruleForm.activityRulesText.length
                          ? ruleForm.activityRulesText.length
                          : 0
                      }}/2000）
                    </div>
                  </div>
                  <div style="margin-left: 8px; margin-top: 16px">
                    <jd-button type="blue" @click="generateRule">
                      生成规则
                    </jd-button>
                  </div>
                  <div class="rule-tip">
                    <jd-tip color="gley">
                      提示：点击按钮自动生成规则，也可以自己编辑信息，手机端规则处显示
                    </jd-tip>
                  </div>
                </el-form-item>
              </div>

              <div class="preview-right">
                <preview-bg
                  ref="updateRef"
                  :ruleForm="customerPaperwork"
                  :prizeSetting="newPrizeSetting"
                  :prizeSettingType="ruleForm.prizeSettingType"
                  :rgb="rgb"
                  :actType="activityData.id"
                  :yAxis="yAxis"
                  :bgUrl="newPreviewUrl"
                  :paperworkType="ruleForm.paperworkType"
                  :ladder="ladder"
                />
              </div>
            </div> -->
          </template>
          <!-- <div v-if="backgroundOpacity" class="backgroundOpacity"></div> -->
        </el-form>
      </div>
    </div>
    <div class="create_bottom">
      <jd-button
        v-if="(localStep != 0&&localStep != 1)||backgroundOpacity"
        v-show="!itemId"
        style="margin-right: 8px"
        @click="clickLocalStep()"
      >
        {{ backgroundOpacity ? "返回列表" : "返回上一步" }}</jd-button
      >
      <jd-button @click="saveDraft" style="margin-right: 8px" v-if="hasDraftBtn"
        >保存至草稿箱</jd-button
      >
      <template v-if="!backgroundOpacity">
        <jd-button
          v-show="!itemId"
          v-if="isSave"
          type="blue"
          @click="saveEdit"
          v-preventReClick
          >保存设置</jd-button
        >
      </template>
      <jd-button v-show="itemId" @click="cancelEdit" style="margin-right: 8px"
        >取消</jd-button
      >
      <jd-button v-show="itemId" type="blue">保存设置</jd-button>
    </div>
    <!-- 添加曝光商品 -->
    <selectGoodsMonitor
      v-if="selectGoodsState"
      ref="selectGo"
      :isShow="selectGoodsState"
      @close="selectGoodsClose"
      :selectGoods="selectGoodsArr"
      :moduleType="true"
      :skuSearch="true"
      :xianz="true"
      :disabled="backgroundOpacity"
      isInteract
    ></selectGoodsMonitor>
    <!-- :skuSearch="true" -->
    <!-- 指定购买商品 -->
    <selectGoodsMonitor
      v-if="selectGoodsStateFilter"
      ref="selectGoFilter"
      :isShow="selectGoodsStateFilter"
      @close="selectGoodsCloseFilter"
      :selectGoods="selectGoodsFilterArr"
      :moduleType="true"
      :skuSearch="true"
      :xianz="false"
      :disabled="backgroundOpacity"
      :venderId="curretnVenderId"
      isInteract
    ></selectGoodsMonitor>
    <!-- 指定金额商品 -->
    <selectGoodsMonitor
      v-if="showAppointFilter"
      ref="appointFilter"
      :isShow="showAppointFilter"
      @close="appointGoodsCloseFilter"
      :selectGoods="appointGoodsFilterArr"
      :moduleType="true"
      :skuSearch="true"
      :xianz="false"
      :disabled="backgroundOpacity"
      isInteract
    ></selectGoodsMonitor>
    <!-- 保存并完成设置弹框 -->
    <el-dialog
      title="重要提示"
      :visible.sync="joinBlackList"
      width="800"
      @close="checked = false"
    >
      <div style="line-height: 25px; margin-bottom: 30px">
        <p>
          1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
        </p>
        <p>
          2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
        </p>
      </div>

      <el-checkbox v-model="checked" label="地址" name="partner"
        >我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox
      >
      <div slot="footer" class="dialog-footer">
        <jd-button @click="joinBlackList = false">取消</jd-button>
        <jd-button
          @click="handleDialogCloseAnoth()"
          type="blue"
          style="margin-left: 8px"
          >确定</jd-button
        >
      </div>
    </el-dialog>

    <!-- 选择奖品弹窗 -->
    <selectProduct
      :typeDefault="typeDefault"
      :num="1"
      :actId="valueRow"
      :echoDate="echoDate"
      :JingdouCount="JingdouCount"
      @close="colseDialog"
      v-if="showDialog"
      ref="selectProduct"
      :actType="actType"
      :actEndTime="ruleForm.endTime"
      @choose-shop="getTheData"
      :isShowFirst="false"
    >
    </selectProduct>
    <!-- 选择人群弹窗 -->
    <selectPeople
      v-if="selectPeopleShow"
      :dialogVisible="selectPeopleShow"
      :peopleList="peopleList"
      @confim="selectPeopleSure"
      @close="selectPeopleShow = false"
    ></selectPeople>
    <!-- 增加奖品弹窗 -->
    <addPrizeNum
      :isShowAddNum="isShowAddNum"
      :prizeData="toAddItem"
      @confirm="confirmAdd"
      @close="isShowAddNum = false"
    />
  </div>
</template>

<script>
import selectPrize from "./select_prize.vue";
import { querymemberLevel } from "@/api/jhk/integralCenter/memberLevel";
import { updateCommon } from "@/api/jhk/integralCenter/integralTask";
import selectProduct from "./select_product_componentization.vue";
import QRCode from "qrcodejs2";
import { mapState, mapMutations } from "vuex";
import selectGoodsMonitor from "@/components/selectGoodsMonitor2.vue";
import draggable from "vuedraggable";
import selectPeople from "@/components/select-people-yunqi.vue";
import addPrizeNum from "./components/add-prize-num.vue";
import previewBg from "./components/preview.vue";
import { getShopList } from "@/api/public";
import {
  getPersonLabelList,
  createShopGift,
  getGiftBagTemplate,
  giftBagEide,
  editShopGift,
  getValidActivity,
  createPurchaseActivity,
  purchaseActivityDetail,
  editPurchaseActivity,
  publicOpen,
  prefixurl,
  hdTaskTemplateGroup,
  sellerImage,
} from "@/api/jhk/paradiseAndTaskCommonController.js";
import { getTaobaoItemListSku } from "@/api/jhk/analysis/ware-controller";
import informationForm from "./components/informationForm.vue"
import activityPageSettings from "./components/activityPageSettings.vue"
import exposureList from "./components/exposureList.vue"
import sharFrom from "./components/sharFrom.vue"
import activityRules from "./components/activityRules.vue"
import { useValidateMoreActSet } from "@/views/interactiveMarketing/activity/components/commDataHook/useBasicInformation.js";

const prizeName = [
  "",
  "",
  "京豆",
  "实物",
  "店铺积分",
  "京东E卡",
  "爱奇艺会员",
  "京东PLUS会员",
  "现金红包",
];
import dailyLimitConfig from "@/views/interactiveMarketing/activity/components/dailyLimitConfig.vue";
export default {
  components: {
    selectProduct,
    selectPrize,
    // SelectGoods,
    selectGoodsMonitor,
    draggable,
    selectPeople,
    addPrizeNum,
    previewBg,
    informationForm,
    activityPageSettings,
    exposureList,
    sharFrom,
    activityRules,
    dailyLimitConfig,
  },
  props: {
    itemId: "",
    stepNum: {
      type: Number,
      default: 0,
    },
    activeValue: {
      type: Number,
    },
    valueRow: null,
    activityData: {
      type: Object,
    },
    isSave: {
      type: Boolean,
      default: true,
    },
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    selectShopsType() {
      let type = 0;
      let venderType1 = 0;
      let venderType2 = 0;
      if(this.ruleDto.venderIds.length > 0) {
        this.ruleDto.venderIds.forEach(item =>{
          const type1 = this.shopList.find(v=> v.venderId == item && v.venderType == true);
          const type2 = this.shopList.find(v=> v.venderId == item && v.venderType == false)
          if(type1) {
            venderType1++;
          }
          if(type2) {
            venderType2++;
          }
        })
      }
      if(venderType1 && venderType2) {
        // 有自营店铺和非自营店铺
        type = 1;
      } else if(venderType1) {
        // 仅自营店铺
        type = 3;
      } else if(venderType2) {
        // 仅pop
        type = 2;
      }
      return type;
    },
    multiShopGoods() {
      if (this.shopList.length > 0) {
        const venderIds = this.ruleDto.venderIds || [];
        return this.shopList.filter((v) =>
          venderIds.includes(v.venderId),
        );
      } else {
        return [];
      }
    },
    getTitle() {
      return (venderId)=>{
        const item = this.shopList.find(v=> v.venderId == venderId)
        if(item) {
          return item.shopTitle
        } else {
          return ""
        }
      }
    },
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
    // 判断是否有草稿箱按钮
    hasDraftBtn() {
      return this.isDraftEdit || !this.valueRow || this.activityData.isCopy;
    },
    newPreviewUrl() {
      return this.ruleForm.paperworkType == 0
        ? this.previewUrl
        : this.previewNoTextUrl;
    },
    newPrizeSetting() {
      if (this.activityData.id == 16 || this.activityData.id == 18) {
        if (this.ruleForm.prizeSettingType == 0) {
          return this.tableData;
        } else {
          return this.ladderData;
        }
      } else {
        return this.tableData;
      }
    },
    // 1: 京获客旗舰版
    softType() {
      return this.$store.getters.loginUserInfo.yunZhouOtherType || '';
    },
    actType() {
      return this.activityData.id;
    }
  },
  watch: {
    "ruleDto.venderIds": {
      handler(newVal, oldVal) {
        if (newVal.length > 0) {
          console.log('ruleDto.venderIds',this.selectShopsType);
          // if(this.selectShopsType == 1 || this.selectShopsType == 3) {
          //   this.ruleForm.popOrderStartPaymentType = 1;
          // } else if(this.selectShopsType == 2) {
          //   if(this.ruleForm.popOrderStartPaymentType!=0) {
          //     this.ruleForm.popOrderStartPaymentType = 1
          //   } 
          //   else {
          //     this.ruleForm.popOrderStartPaymentType = 0;
          //   }
          // }
        }
      }
    },
    localStep(newVal) {
      if (newVal == 0) {
        this.$nextTick(() => {
          this.getCodeIMG();
        });
      } else {
        this.buriedPoint(1, this.activityData.name, "互动管理", "互动活动");
      }
    },
    'ruleForm.lockPrizeType': {
      handler(newVal, oldVal) {
        if (newVal == 0) {
          this.ruleForm.lockPrizeDay = ''
        }
      }
    },
  },
  filters: {
    prizeType(num,type) {
      var result = "";
      if (num == "1") {
        result = "优惠券";
      } else if (num == "2") {
        result = "京豆";
      } else if (num == "3") {
        result = "实物";
      } else if (num == "4") {
        result = "店铺积分";
      } else if (num == "5") {
        result = "京东E卡";
      } else if (num == "6") {
        result = "爱奇艺会员";
      } else if (num == "7") {
        result = "京东PLUS会员";
      } else if (num == "8") {
        result = "现金红包";
      } else if (num == "10") {
        result = "礼品卡";
      } else if (num == "12") {
        result = type ? "令牌" : '专享价';
      } else if (num == "13") {
        result = "令牌";
      } else if (num == "14") {
        result = "实物（随单发）";
      } 
      return result;
    },
  },
  data() {
    return {
      isForceRemind:false,
      isKeyActivity: 0,
      placementPosition: [],
      cusTemplateJSON:"",

      actEndTime: "",
      orderStartTime: "",
      orderEndTime: "",
      isShowTip: false,
      isShowEndTip: false,
      includeArr: [], //指定商品
      excludeArr: [], //排除商品
      // 1.14迭代
      ruleDto: {
        isCheckOpenCardTime: false,
        openCardStartTime: "",
        openCardEndTime: "",
        plusObject: 0, //plus会员
        sendType: 0, // 奖品发放形式：0立即发放，1确认收货后发放，2活动结束后发放
        sendDay: "", // 发放天数，当sendType为1或2时有效
        filterSkuType: 0, //指定商品规则
        venderIds: [], //新增下单店铺
        multiShopSkuType: 0,
        skuBelongVenderId: "",
        // 多店铺指定商品
        sellerSkuList: [],
      },
      openCardStartTimeOptionsValue: {
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 8.64e7 ||
            time.getTime() >
              new Date(this.ruleDto.openCardEndTime).valueOf() -
                24 * 60 * 60 * 1000
          );
        },
      },
      openCardEndTimeOptionsValue: {
        disabledDate: (time) => {
          return (
            time.getTime() < new Date(this.ruleDto.openCardStartTime).valueOf()
          );
        },
      },

      actMember: "1",
      isNongfu:
        (this.$store.state.loginUserInfo.venderId == "709005" ||
          this.$store.state.loginUserInfo.venderId == "1000008814"
        ) &&
        this.activityData.id == 16
          ? true
          : false,
      // 如果要使用茗茶坊账号本地调农夫山泉就打开这段代码
      // isNongfu:
      //   (this.$store.state.loginUserInfo.venderId == "709005" ||
      //     this.$store.state.loginUserInfo.venderId == "1000008814" ||
      //     this.$store.state.loginUserInfo.venderId == "13315956") &&
      //   this.activityData.id == 16
      //     ? true
      //     : false,
      telCode: `https://yq-hd-rc.isvjcloud.com/clientPreview?venderId=${this.$store.state.loginUserInfo.venderId}`,
      templateId: "",
      tabActive: 0,
      navItem: { id: "" },
      giftList: [],
      pageData: {
        size: 10000,
        current: 1,
        total: 0,
      },
      tempSwitchList: [
        {
          isVisible: true,
          title: "全部",
          id: -1,
        },
      ],
      templateUItype: 1, //模板类型
      echoDate: {},
      defaultTime: [
        this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length),
        this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length),
      ],
      activityTimeValue: this.$getDate(30),
      pickerOptionsValue: {
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 8.64e7 ||
            time.getTime() >
              new Date(this.ruleForm.activityEndime).valueOf() -
                24 * 60 * 60 * 1000
          );
        },
      },
      pickerOptionsValueEnd: {
        disabledDate: (time) => {
          return (
            time.getTime() < Date.now() - 8.64e7 ||
            time.getTime() < new Date(this.ruleForm.activityStartTime).valueOf()
          );
        },
      },
      JingdouCount: {
        prizeCount: 0,
      },
      typeDefault: {
        grantType: 5, // 发放类型  传对应的id值
        display: 1, // 是否公开  传对应的id值
        type: 0, // 不禁用  传对应的id值
        noDisabled: [5], // 不禁用  传对应的id值  可不传（全部可选）
      },
      selectGoodsStateFilter: false,
      showAppointFilter: false,
      itemListForFilter: [],
      appointListForFilter: [],
      selectGoodsFilterArr: [],
      appointGoodsFilterArr: [],
      giftPrizeType: [], // 礼包样式数量
      fromLoading: false, // 数据加载 显示
      loading: false, // 数据加载 显示
      giftID: "", // 礼包id
      giftList: [], // 礼包模板
      disableVF: true, // 人群禁用
      disableCUS: true, //  人群禁用
      dialogPrize: false, // 弹窗
      currtIndex: -3,
      libaoItem: {}, // 选中的item
      // 人群多选
      verCheckAll: false,
      starCheckAll: false,
      // dialogPrize: true,
      levelList: [],
      disableTime: false,
      clickActual: false,
      qrcode: null,
      order: "",
      showDialog: false,
      testInfo: [], //动态添加完善信息
      momentValue: {}, //编辑回显
      isShow: false,
      prizeSettingList: {
        price: null,
        title: "",
        assetsId: null,
        prizeType: null,
        logo: "",
        discount: "",
        singleAmount: "",
      },
      //时间限制
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.ruleForm.activityStartTime) {
            const day = 24 * 60 * 60 * 1000;
            //Note:日期减一 如果是00:00:00的话 就不需要减
            if (this.ruleForm.activityStartTime.indexOf("00:00:00") > -1) {
              return (
                time.getTime(time) <
                new Date(this.ruleForm.activityStartTime).getTime()
              );
            } else {
              return (
                time.getTime(time) + day <
                new Date(this.ruleForm.activityStartTime).getTime()
              );
            }
          } else {
          }
        },
      },
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.ruleForm.activityEndTime) {
            return (
              time.getTime() >
                new Date(this.ruleForm.activityEndTime).getTime() ||
              time.getTime() < Date.now() - 8.64e7
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
        selectableRange: (() => {
          let data = new Date();
          let hour = data.getHours();
          let minute = data.getMinutes();
          let second = data.getSeconds();
          return [`${hour}:${minute}:${second} - 23:59:59`];
        })(),
      },
      //下单时间限制
      pickerOrderEnd: {
        disabledDate: (time) => {
          if (this.ruleForm.orderStartTime) {
            const day = 24 * 60 * 60 * 1000;
            //Note:日期减一 如果是00:00:00的话 就不需要减
            if (this.ruleForm.orderStartTime.indexOf("00:00:00") > -1) {
              return (
                time.getTime(time) <
                new Date(this.ruleForm.orderStartTime).getTime()
              );
            } else {
              return (
                time.getTime(time) + day <
                new Date(this.ruleForm.orderStartTime).getTime()
              );
            }
          } else {
          }
        },
      },
      pickerOrderStart: {
        disabledDate: (time) => {
          if (this.ruleForm.orderEndTime) {
            return (
              time.getTime() > new Date(this.ruleForm.orderEndTime).getTime()
            );
          } else {
          }
        },
      },
      orderFinishStartPickerOptions: {
        disabledDate: (time) => {
          // 如果有结束时间，开始时间不能晚于结束时间
          if (this.ruleForm.orderFinishEndTime) {
            return time.getTime() > new Date(this.ruleForm.orderFinishEndTime).getTime();
          }
          return false;
        }
      },
      orderFinishEndPickerOptions: {
        disabledDate: (time) => {
          // 如果有开始时间，结束时间不能早于开始时间
          if (this.ruleForm.orderFinishStartTime) {
            return time.getTime() < new Date(this.ruleForm.orderFinishStartTime).getTime();
          }
          return false;
        }
      },
      //每日签到
      checked: false,
      joinBlackList: false,
      draggingId: [], //有拖拽时要传的ID顺序
      saveValue: [],
      mainImagelist: [], //图片拖拽排序
      isDragging: false,
      itemListFor: [], //商品弹框选择商品数据
      selectGoodsState: false, //曝光商品弹窗
      selectGoodsArr: [],
      selectGoodsArr2: [],
      ele: "", //点击保存添加一行
      timeDay: 0, //活动持续天数
      timeOut: 0, //多少小时
      limit: true,
      itemArr: [
        {
          continueSignPoints: "",
          days: "",
        },
      ],
      itemArrOne: [],
      localStep: this.stepNum,
      localStepNum: this.activityData.id,
      activityStartTime: null,
      activityEndTime: null,
      ruleForm: {
        firstOpenCardTimeType: 0, // 首次入会时间类型
        openCardBeforeDay: "", // 参与活动前N天
        openCardFollow: 0, // 开卡入会后方可参与活动
        popOrderStartPaymentType: 1,
        prizeSettingType: 0,
        //设置规则表单
        activityName: "",
        partner: ["-1"],
        isFollow: false,
        prizeSet: [],
        inputprize: "",
        exposureSwitch: false,
        isLimitSkuAmt: false,
        skuStartPayment: "",
        skuEndPayment: "",
        radio: 0,
        startTime: "",
        prizeSite: "",
        information: [],
        activityStartTime: null, //活动开始时间
        activityEndTime: null, //活动结束时间
        singScore: null,
        activityRulesText: "", //生成规则
        bonusPoints: "", //活动名称，关注店铺有礼奖品设置积分
        peopleCount: "", //邀请开卡
        prizeSetOne: false,
        prizeCount: null,
        informationOne: [],
        isCumulativePrize: false,
        // 复购 首单专享礼 下单
        condFollow: false, // 是否需要关注店铺
        days: "100", //近X天内未购
        orderStartTime: "", //下单开始时间
        orderEndTime: "", //下单结束时间
        orderStartCount: "", //订单开始笔数
        orderEndCount: "", //订单结束笔数
        orderStartPayment: "", //订单开始金额
        orderEndPayment: "", //订单结束金额
        filterType: "0", //过滤商品：0全部商品 1指定商品 2排除商品
        skuIdList: "", //skuId集合，多个，隔开
        // 开卡  店铺
        modelIds: "", //活动对应的人群包id
        vermicelliVal: [], //活动对应的人群包多选
        starVal: [], //活动对应的人群包多选
        sendCount: "", //发送人数
        isOutClose: "", //勾选奖品发完是否自动结束活动
        isExposureItem: "", //是否添加曝光商品 0 否 1 是

        isMemberGiftCheck: false,
        isHavePrizes: "2",
        prizes: [], // 礼包样式  积分  京豆等等
        itemList: [], //曝光商品集合
        // 分享设置
        shareTitle: "",
        shareIntroduce: "",
        sharePic: "",
        days: "90",
        joinType: 0,
        orderFinishStartTime: '', // 复购规则-开始时间
        orderFinishEndTime: '', // 复购规则-结束时间

        goShopSetting: 0, //进店设置
        goShopAppId: "", //小程序appId
        goShopUrl: "", //小程序页面路径
        isSupportOrderList: 0,
        supportRollback: 0, //是否支持奖品撤回
        supportCancelOrderRebind: 0, //是否支持订单取消后可重新绑定其他订单领取奖品
        firstBuyRule: 0, // 首单专享规则
        paperworkType: 0, //活动模板文案
        lockPrizeType: 0,//锁定奖品类型
        lockPrizeDay: '', // 锁定奖品时间
        isValidBlackList: 0,
        mergeOrder: false,
      },
      sharePic: "", // 默认分享图
      tableData: [
        {
          peopleCount: "",
          prizeType: "",
          discount: "",
          prizeCount: "",
          singleAmount: "",
        },
      ],
      ladder: {
        prizeShowType: 0,
        orderCountType: 0,
      },
      thresholdList: [
        {
          value: 0,
          label: "单笔满",
        },
        {
          value: 1,
          label: "累计满",
        },
      ],
      ladderData: [
        {
          orderAmtLimit: "", //订单门槛orderAmtLimit
          itemTotalLimit: "", //商品件数门槛itemTotalLimit
          peopleCount: "",
          prizeType: "",
          discount: "",
          prizeCount: "",
          singleAmount: "",
        },
        {
          orderAmtLimit: "", //订单门槛
          itemTotalLimit: "", //商品件数门槛
          peopleCount: "",
          prizeType: "",
          discount: "",
          prizeCount: "",
          singleAmount: "",
        },
      ],
      tableIndex: null,
      rules: {
        // 表单规则校验
        activityName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          {
            min: 3,
            max: 15,
            message: "长度在 3 到 25 个字符",
            trigger: "blur",
          },
        ],
        isLongTime: [
          { required: true, message: "请选择活动时间", trigger: "change" },
        ],
        activityRulesText: [
          { required: true, message: "请填写活动规则", trigger: "blur" },
        ],
        partner: [
          {
            type: "array",
            required: true,
            message: "至少选择一个",
            trigger: "change",
          },
        ],
        prizeSet: [
          {
            type: "array",
            required: true,
            message: " ",
            trigger: "change",
          },
        ],
        startTime: [{ required: true, message: "请选择开始时间" }],
        choosePrize: [{ required: true, message: "请选择奖品" }],
        prizeCount: [{ required: true, message: "请输入奖品数量" }],
        prizeSite: [{ required: true, message: " ", trigger: "blur" }],
        information: [{ required: true, message: " " }],
      },
      orderCRM: false,
      orderCRMtime: "",
      activityUrl: "",
      venderId: "",
      isStart: false,
      selectPeopleShow: false,
      peopleList: [],
      peopleSelected: [],
      isDraft: false,
      toAddItem: null,
      isShowAddNum: false,
      toAddBelong: "",
      toAddIndex: 0,
      customerPaperwork: {
        title: "",
        desc: "",
        titleColor: "",
        descColor: "",
      },
      rgb: "#fff",
      rgb2: "#fff",
      rgb3: "#fff",
      previewUrl: "",
      previewNoTextUrl: "",
      yAxis: 0,
      // 当前选择店铺id
      curretnVenderId: "",
      shopList: [],
    };
  },
  async created() {
    this.isStart = this.activityData.isStart ? true : false;
    // 数据初始化
    this.init();
    console.log("当前玩法id", this.activityData.id);
    this.sharePic = this.getDefaultSharePic(this.activityData.id);
    this.ruleForm.sharePic = this.sharePic;
    this.ruleForm.shareTitle = `我分享了一个${this.activityData.name}活动给你，快来看看吧！`;
    this.ruleForm.shareIntroduce = `我在京东有新发现，绝对适合你，速来围观～`;
    await this.getShopAllList();
    if (this.activeValue) {
      this.activityData.id = this.activeValue;
      this.getEdit();
    } else {
      this.ruleDto.sellerSkuList = this.ruleDto.sellerSkuList.length == 0 ? [{
        venderId: this.$store.getters.loginUserInfo.venderId,
        skuIds: [],
        itemList: [],
      }] : this.ruleDto.sellerSkuList;
      this.ruleDto.venderIds = [Number(this.$store.getters.loginUserInfo.venderId)]
    }
    // 新增活动默认时间
    if (!this.valueRow) {
      this.ruleForm.activityStartTime = this.$getDate(30)[0];
      this.ruleForm.activityEndTime = this.$getDate(30)[1];
      this.activityTimeChange();
    }
  },
  mounted() {
    this.getLevel();
    this.hdTaskTemplateGroup();
    this.$nextTick(() => {
      this.getCodeIMG();
      // this.qrcodeAll(this.activityData.telCode, queryId);
    });
    //存储拖拽前的数据
    this.mainImagelist = JSON.parse(sessionStorage.getItem("mainImagelist"));
    // console.log(this.activeValue, 99996);
  },
  methods: {
    viewMergeLogic() {
      window.open("https://www.yuque.com/yunduanxincrm/mrkpcq/mub1q6wafxefavp4?singleDoc#")
    },
    viewStatisticsLogic() {
      window.open("https://www.yuque.com/yunduanxincrm/mrkpcq/ribmlurbi01iznn8?singleDoc#")
    },
    orderSelectGoods(venderId) {
      if (this.ruleForm.filterType != 0) {
        this.curretnVenderId = venderId;
      }
      if (this.ruleDto.sellerSkuList.length > 0) {
        this.selectGoodsFilterArr = this.ruleDto.sellerSkuList.filter(
          (item) => item.venderId == venderId,
        )[0].itemList;
      }
      this.selectGoodsStateFilter = true;
    },
    async getShopAllList() {
      return new Promise((resolve,reject) => {
        getShopList()
          .then((res) => {
            if (res.code == 1) {
              const resData = res.data.filter(item=> item)
              if (resData && resData.length){
                this.shopList = resData;
              } else {
                this.shopList = [
                  {
                    shopTitle: this.$store.getters.loginUserInfo.shopTitle,
                    venderId: this.$store.getters.loginUserInfo.venderId,
                    venderType: this.venderType,
                    defaultFlag: true,
                  },
                ];
              }
            } else {
              this.shopList = [
                {
                  shopTitle: this.$store.getters.loginUserInfo.shopTitle,
                  venderId: this.$store.getters.loginUserInfo.venderId,
                  venderType: this.venderType,
                  defaultFlag: true,
                },
              ];
            }
            resolve();
          })
          .catch(() => {
            this.shopList = [
              {
                shopTitle: this.$store.getters.loginUserInfo.shopTitle,
                venderId: this.venderId,
                venderType: this.venderType,
                defaultFlag: true,
              },
            ];
            resolve();
          });
      })
    },
    checkShopChange(shopList) {
      // 1. 保存当前已选择的skuIds映射
      const existingSkuMap = new Map();
      this.ruleDto.sellerSkuList.forEach((item) => {
        existingSkuMap.set(item.venderId + "", item.skuIds);
        existingSkuMap.set(item.venderId + "itemList", item.itemList);
      });
      // 2. 清空现有列表但保留映射关系
      this.ruleDto.sellerSkuList = [];
      // 3. 重新添加选中店铺，恢复原有skuIds
      shopList.forEach((venderId) => {
        // 查找店铺信息
        const shopInfo = this.shopList.find(
          (shop) => shop.venderId == venderId,
        );
        if (shopInfo) {
          this.ruleDto.sellerSkuList.push({
            venderId: venderId,
            // 恢复已选择的skuIds，新店铺则初始化为空数组
            skuIds: existingSkuMap.get(venderId + "") || [],
            itemList: existingSkuMap.get(venderId + "itemList") || [],
          });
        }
      });
    },
    // 验证发放天数输入
    validSe(e) {
      const num = String(e).replace(/\D/g, '');
      if (num && num > 365) {
        this.$message.warning('天数不能大于365天');
        return '365';
      }
      return num;
    },
    
    selectTemplate(index,templateId,items){
       //新增判断
      if (this.orderCRM) {
        return this.$message.warning(
          "自营店铺需要搭配云短信CRM使用！请联系客服！"
        );
      } else {
        this.localStepNum = this.activityData.id;
        // this.localStep = 1;
        this.templateUItype = items.templateUItype;
        this.rgb = items.rgb;
        this.rgb2 = items.rgb2;
        this.rgb3 = items.rgb3;
        this.previewUrl = items.url;
        this.previewNoTextUrl = items.url3;
        this.customerPaperwork.titleColor = items.rgb3;
        this.customerPaperwork.descColor = items.rgb2;
        this.yAxis = Number(items.yAxis);
        if (templateId) {
          this.templateId = templateId;
        }
        this.$emit("titopName", this.activityData.name, true);
      }
    },
    handleSettingType(val) {
      if (val == 0) {
        this.ladderData = [
          {
            orderAmtLimit: "", //订单门槛orderAmtLimit
            itemTotalLimit: "", //商品件数门槛itemTotalLimit
            peopleCount: "",
            prizeType: "",
            discount: "",
            prizeCount: "",
            singleAmount: "",
          },
          {
            orderAmtLimit: "", //订单门槛
            itemTotalLimit: "", //商品件数门槛
            peopleCount: "",
            prizeType: "",
            discount: "",
            prizeCount: "",
            singleAmount: "",
          },
        ];
      } else {
        this.tableData = [
          {
            peopleCount: "",
            prizeType: "",
            discount: "",
            prizeCount: "",
            singleAmount: "",
          },
          {
            peopleCount: "",
            prizeType: "",
            discount: "",
            prizeCount: "",
            singleAmount: "",
          },
        ];
      }
    },
    // 改变数量值
    confirmAdd(num) {
      let { toAddBelong, toAddIndex } = this;
      this[toAddBelong][toAddIndex].prizeCount = num;
      this.isShowAddNum = false;
    },
    // 获取相关数据打开弹窗
    itemAddNum(arrStr, index) {
      this.toAddItem = {
        ...this[arrStr][index],
        num: this[arrStr][index].prizeCount,
      };
      if (!this.toAddItem.title) {
        this.$message.error("没有奖品不能设置数量！");
        return;
      }
      this.toAddBelong = arrStr;
      this.toAddIndex = index;
      this.isShowAddNum = true;
    },
    onShopSetChange(value) {
      this.ruleForm.goShopAppId = "";
      this.ruleForm.goShopUrl = "";
    },
    // 1.14迭代
    clearNewTime() {
      this.ruleDto.openCardStartTime = "";
      this.ruleDto.openCardEndTime = "";
    },
    setNumber(rawValue, minValue = 1, allowDecimals) {
      console.log(rawValue);
      if (rawValue == "") {
        return "";
      }
      // 尝试将原始值转换为数字
      let value = Number(rawValue);
      // 如果转换失败或小于最小值，则返回最小值
      if (isNaN(value) || value <= minValue) {
        return minValue;
      }
      // 如果不允许小数，则取整
      if (allowDecimals) {
        value = Math.floor(value);
      }
      // 返回值
      return value;
    },

    // 打开选择人群
    openCrowd() {
      this.peopleList = this.peopleSelected.map((item) => {
        return { id: item };
      });
      this.selectPeopleShow = true;
      this.actMember = "3";
    },
    // 选择人群关闭
    selectPeopleSure(val) {
      this.peopleSelected = val.map((item) => item.id);
      this.selectPeopleShow = false;
    },
    // 京东计划数量计算
    prizeNum(row) {
      // 京豆计划已在其他函数判断，这里只计算 京东E卡、plus、爱奇艺、红包
      if ([5, 6, 7, 8, 10].includes(Number(row.prizeType))) {
        if (
          Number(row.prizeCount) &&
          Number(row.prizeCount) > row.budgetRemain
        ) {
          row.prizeCount = "";
          if (row.prizeType == 5)
            this.$message.error(
              "京东E卡总份额数量不能大于该京东E卡剩余预算额！"
            );
          if (row.prizeType == 6)
            this.$message.error(
              "爱奇艺会员总份额数量不能大于该爱奇艺会员剩余预算额！"
            );
          if (row.prizeType == 7)
            this.$message.error(
              "京东PLUS会员总份额数量不能大于该京东PLUS会员剩余预算额！"
            );
          if (row.prizeType == 8)
            this.$message.error(
              "现金红包总份额数量不能大于该现金红包剩余预算额！"
            );
          if (row.prizeType == 10)
            this.$message.error("礼品卡总份额数量不能大于该礼品卡剩余预算额！");
        }
      }
    },
    // 活动进行中修改奖品数量
    beAdd(row) {
      console.log(row);
      if (this.isStart) {
        if (row.prizeCount < row.minNum && row.minNum) {
          row.prizeCount = row.minNum;
          this.$message.warning("为避免客诉，奖品数量不能小于之前哦~");
        }
      }
    },
    //上传图片前校验   分享设置
    beforeUpload1(file) {
      let _this = this;
      let image = new Image();
      let _URL = window.URL || window.webkitURL;
      image.onload = function () {
        const valid = image.width == 200 && image.height == 200;
        file.isFlag = valid;
        _this.uploadSize = valid;
        console.log(valid);
        if (valid) {
        } else {
          _this.$message.info("图片宽高不符合要求,请重新上传");
          sizetype = false;
          return false;
        }
      };
      image.src = _URL.createObjectURL(file);
      console.log(file);
      const isLt3M = file.size < 1024 * 1024;

      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"];
      let sizetype = false;
      if (!isLt3M) {
        this.$message.info("上传图片大小不能超过 1MB");
        return false;
      }
      if (sorts.indexOf(type) < 0) {
        this.$message.info("所选文件格式不符，请重新选择");
        return false;
      }
    },
    // 上传成功  分享设置
    handleUpload1(res) {
      if (res.code != 1) {
        this.$message.error(res.message);
      } else {
        console.log(this.uploadSize);
        if (this.uploadSize) {
          this.ruleForm.sharePic = res.data;
          // console.log(this.ruleForm.sharePic);
        }
      }
    },
    // 重置背景图  分享设置
    picUrlReset1() {
      if (this.activityData.isStart) return;
      this.ruleForm.sharePic = this.sharePic;
    },
    getDaysBetween(dateString1, dateString2) {
      const startDate = Date.parse(dateString1);
      const nowDate = Date.parse(new Date());
      // console.log(nowDate,startDate);
      const endDate = Date.parse(dateString2);
      if (startDate > endDate) {
        return 0;
      }
      if (startDate == endDate) {
        return 1;
      }
      let days = 0;
      if (nowDate > startDate) {
        days = (endDate - nowDate) / (1 * 24 * 60 * 60 * 1000);
      } else {
        days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      }
      // console.log(days);

      return Math.floor(days) == 0 ? "1天" : Math.ceil(days) + "天";
    },

    handleNav(item, index) {
      this.tabActive = index;
      this.navItem = item;
      this.getPolite();
    },

    // 模板类型
    async hdTaskTemplateGroup() {
      const { data } = await hdTaskTemplateGroup({
        hdTaskType: this.activityData.id,
      });
      this.tempSwitchList = [
        {
          id: -1,
          groupName: "全部",
          frontHide: false,
        },
        ...data,
      ];
      this.tempSwitchList.map((item) => {
        item.isVisible = true;
        item.title = item.groupName;
      });
      this.getPolite();
    },

    // 活动模板
    async getPolite() {
      let params = {
        current: this.pageData.current,
        size: this.pageData.size,
        templateGroupId: this.navItem.id == -1 ? "" : this.navItem.id,
        source: 4,
        hdTaskType: this.activityData.id,
      };
      const { data } = await sellerImage(params);
      this.giftList = data.records.map((item) => {
        return {
          ...item,
          days: item.activityStartTime
            ? this.getDaysBetween(item.activityStartTime, item.activityEndTime)
            : "",
        };
      });

      if (this.activeValue) {
        let arr = this.giftList.filter((item) => item.id == this.templateId);
        this.rgb = arr[0].rgb;
        this.rgb2 = arr[0].rgb2;
        this.rgb3 = arr[0].rgb3;
        this.previewUrl = arr[0].url;
        this.previewNoTextUrl = arr[0].url3;
        this.yAxis = Number(arr[0].yAxis);
      }
      if(!this.templateId){
        this.selectTemplate(0,this.giftList[0].id,this.giftList[0])
      }
      this.pageData.total = data.total * 1;
      this.$nextTick(() => {
        this.getCodeIMG();
      });
    },

    // 数据初始化
    async init() {
      const { message: res } = await publicOpen();
      if (res) {
        this.orderCRMtime = res;
        this.orderCRM = false;
        if (this.venderType) {
          this.ruleForm.popOrderStartPaymentType = 1;
        }
      } else {
        if (this.venderType) {
          this.orderCRM = true;
          this.ruleForm.popOrderStartPaymentType = 1;
        } else {
          this.orderCRM = false;
        }
        this.orderCRMtime = "";
      }
      const data = await prefixurl();
      this.activityUrl = data.data.activityUrl;
      this.venderId = data.data.venderId;
      if (!this.activeValue) {
        if (this.activityData.id == 16) {
          this.customerPaperwork.title = "下单有礼";
          this.customerPaperwork.desc = "超多好礼送不停";
        } else if (this.activityData.id == 17) {
          this.customerPaperwork.title = "首单专享礼";
          this.customerPaperwork.desc = "奖品送不停";
        } else if (this.activityData.id == 18) {
          this.customerPaperwork.title = "复购有礼";
          this.customerPaperwork.desc = "超多好礼送不停";
        }
      }
    },
    // 修改 数据回显
    getEdit() {
      purchaseActivityDetail(this.valueRow.id).then((res) => {
        // this.activityTimeValue = [
        //   String(res.data.startTime),
        //   String(res.data.endTime),
        // ];
        this.ruleForm.activityName =
          res.data.activityName + (this.activityData.isCopy ? "复制" : "");
        this.ruleForm.activityStartTime = res.data.startTime
          ? String(res.data.startTime)
          : null;
        this.ruleForm.activityEndTime = res.data.endTime
          ? String(res.data.endTime)
          : null;
        this.actEndTime = res.data.endTime;
        // this.ruleForm.bonusPoints = String(res.data.pointActivityPrizeDTO.price);
        this.ruleForm.partner = res.data.allowLevel.split(",");
        // if (this.venderType) {
        //   this.ruleForm.popOrderStartPaymentType = 1;
        // } else {
          
        // }
        this.ruleForm.popOrderStartPaymentType = res.data.ruleDto
          .popOrderStartPaymentType===null 
            ? 1
            : res.data.ruleDto.popOrderStartPaymentType;
        this.ruleForm.mergeOrder = res.data.ruleDto.mergeOrder || false;
        // 1.14迭代这里回显
        this.ruleDto = {
          isCheckOpenCardTime: res.data.ruleDto.isCheckOpenCardTime,
          openCardStartTime: res.data.ruleDto.openCardStartTime,
          openCardEndTime: res.data.ruleDto.openCardEndTime,
          plusObject: res.data.ruleDto.plusObject, //plus会员
          sendType: res.data.ruleDto.sendType || 0, // 奖品发放形式：0立即发放，1确认收货后发放，2活动结束后发放
          sendDay: res.data.ruleDto.sendDay || "", // 发放天数，当sendType为1或2时有效
          filterSkuType: 0,
          sellerSkuList: (!res.data.ruleDto.sellerSkuList || (res.data.ruleDto.sellerSkuList&&res.data.ruleDto.sellerSkuList.length == 0)) ? [{
            venderId: this.$store.getters.loginUserInfo.venderId || this.venderId,
            skuIds: res.data.ruleDto.skuIdList || [],
            itemList: [],
          }] : res.data.ruleDto.sellerSkuList,
          venderIds: (!res.data.ruleDto.venderIds || (res.data.ruleDto.venderIds&&res.data.ruleDto.venderIds.length == 0)) ? [Number(this.$store.getters.loginUserInfo.venderId)] : res.data.ruleDto.venderIds,
          multiShopSkuType: res.data.ruleDto.multiShopSkuType || 0,
          skuBelongVenderId: res.data.ruleDto.skuBelongVenderId || "",
        };
        if (this.activityData.isCopy||this.isDraftEdit) {
          // 跨店复制
          if(this.ruleDto.venderIds.length>0) {
            let index = this.ruleDto.venderIds.findIndex((item)=>{
              return item == this.$store.getters.loginUserInfo.venderId
            })
            if(index==-1) {
              this.ruleDto.venderIds.unshift(Number(this.$store.getters.loginUserInfo.venderId))
              this.ruleDto.sellerSkuList.unshift({
                venderId: Number(this.$store.getters.loginUserInfo.venderId),
                skuIds: [],
                itemList: [],
              })
            }
          }
        }
        // 多店铺商品回显
        if(this.ruleDto.sellerSkuList.length > 0){
          let reqFn = []
          this.ruleDto.sellerSkuList.forEach(item=>{
            reqFn.push(getTaobaoItemListSku({
              current: 1,
              size: item.skuIds.length,
              venderId: item.venderId,
              skuIdStr: item.skuIds.join(",")
            }))
          })
          Promise.all(reqFn).then((res)=>{
            // 处理返回结果，将接口数据映射到对应item
            this.ruleDto.sellerSkuList.forEach((item, index) => {
              console.log('res[index].data.records',res[index].data.records);
              
              item.itemList = res[index].data.records || [];
              // 补充商品信息到itemList
              item.itemList.forEach(skuItem => {
                skuItem.wareTitle = skuItem.title;
                skuItem.isAdd = skuItem.isAddCart;
              });
            });
          })
        }
        if(res.data.ruleDto.isForceRemind ){
          this.isForceRemind = res.data.ruleDto.isForceRemind 
        }
        this.isKeyActivity = res.data.isKeyActivity||0;
        this.placementPosition = res.data.placementPosition ? res.data.placementPosition.split(",") : ["SHOP"]
        // 学生身份
        this.ruleForm.studentSatus = res.data.studentSatus || "";
        if(res.data.ruleDto.cusTemplateJSON){
          this.cusTemplateJSON = res.data.ruleDto.cusTemplateJSON 
        }

        //tapd 进店逛逛
        this.ruleForm.goShopSetting = res.data.ruleDto.goShopSetting;
        this.ruleForm.goShopAppId = res.data.ruleDto.goShopAppId;
        this.ruleForm.goShopUrl = res.data.ruleDto.goShopUrl;

        this.ruleForm.supportRollback = res.data.ruleDto.supportRollback;
        this.ruleForm.supportCancelOrderRebind = res.data.ruleDto.supportCancelOrderRebind || 0;
        this.ruleForm.firstBuyRule = res.data.ruleDto.firstBuyRule;
        this.ruleDto.filterSkuType = res.data.ruleDto.filterSkuType || 0;
        if (res.data.allowLevel == "99") {
          this.peopleSelected = res.data.crowdIds.split(",");
          this.actMember = "3";
        } else if (res.data.allowLevel == "-1") {
          this.actMember = "1";
        } else {
          this.actMember = "2";
          if (res.data.allowLevel.indexOf("-1") != -1) {
            this.ruleForm.partner = ["-1"];
          }
        }
        // 奖品
        this.ruleForm.condFollow =
          res.data.ruleDto.condFollow == 1 ? true : false;
        this.ruleForm.openCardFollow = res.data.ruleDto.openCardFollow
        this.ruleForm.firstOpenCardTimeType = res.data.ruleDto.firstOpenCardTimeType
        this.ruleForm.openCardBeforeDay = res.data.ruleDto.openCardBeforeDay
        if (this.activityData.id != 16) {
          this.ruleForm.days = res.data.ruleDto.days;
        }
        this.templateUItype = res.data.templateJson
          ? JSON.parse(res.data.templateJson).templateUItype
          : 1;
        this.ruleForm.orderStartTime = res.data.ruleDto.orderStartTime;
        this.ruleForm.orderEndTime = res.data.ruleDto.orderEndTime;
        // 拷贝一份数据做判断
        this.orderStartTime = res.data.ruleDto.orderStartTime;
        this.orderEndTime = res.data.ruleDto.orderEndTime;
        this.ruleForm.orderStartCount = res.data.ruleDto.orderStartCount;
        this.ruleForm.orderEndCount = res.data.ruleDto.orderEndCount;
        this.ruleForm.orderStartPayment = res.data.ruleDto.orderStartPayment;
        this.ruleForm.orderEndPayment = res.data.ruleDto.orderEndPayment;
        this.ruleForm.isLimitSkuAmt = res.data.ruleDto.isLimitSkuAmt;
        this.ruleForm.skuStartPayment = res.data.ruleDto.skuStartPayment;
        this.ruleForm.skuEndPayment = res.data.ruleDto.skuEndPayment;
        this.ruleForm.filterType = String(res.data.ruleDto.filterType);
        this.ruleForm.shareTitle = res.data.ruleDto.shareTitle;
        this.ruleForm.shareIntroduce = res.data.ruleDto.shareIntroduce;
        this.ruleForm.sharePic = res.data.ruleDto.sharePic;
        this.ruleForm.isValidBlackList = res.data.isValidBlackList;
        this.ruleForm.prizeSettingType = res.data.ruleDto.prizeSettingType || 0;
        this.ruleForm.days = res.data.ruleDto.days || "";
        this.ruleForm.joinType = res.data.ruleDto.joinType || 0;
        if (res.data.ruleDto.joinType == 2) {
          this.ruleForm.orderFinishStartTime = res.data.ruleDto.orderFinishStartTime || '';
          this.ruleForm.orderFinishEndTime = res.data.ruleDto.orderFinishEndTime || '';
        }
        this.ruleForm.lockPrizeType = res.data.ruleDto.lockPrizeType || 0; //锁定奖品类型
        this.ruleForm.lockPrizeDay = res.data.ruleDto.lockPrizeDay || ''; //锁定奖品时间
        this.ruleForm.isSupportOrderList = res.data.ruleDto.isSupportOrderList;
        this.ruleForm.paperworkType = res.data.ruleDto.paperworkType
          ? res.data.ruleDto.paperworkType
          : 0;
        this.templateId = res.data.templateId;
        if (this.ruleForm.paperworkType == 1) {
          this.customerPaperwork = JSON.parse(
            res.data.ruleDto.customerPaperwork
          );
        }
        this.customerPaperwork = JSON.parse(
          res.data.ruleDto.customerPaperwork
        );
        if (this.ruleForm.joinType == null) this.ruleForm.joinType = 0;
        if (this.activityData.id == 18 && this.ruleForm.joinType == 0) {
          this.ruleForm.days = "";
        }
        if (res.data.ruleDto.prizeSettingType == 1) {
          this.ladder.prizeShowType = res.data.ruleDto.prizeShowType;
          this.ladder.orderCountType = res.data.ruleDto.orderCountType;
        }

        if (this.ruleForm.isLimitSkuAmt) {
          this.appointListForFilter = res.data.ruleDto.limitSkuList || [];
          this.appointGoodsFilterArr = this.appointListForFilter;
        }
        let ladderData = [];
        let tableData = []
          if (res.data.ruleDto.prizeSettingType == 1) {
            ladderData = res.data.pointActivityPrizeDTOList? res.data.pointActivityPrizeDTOList.map(
              (item, index) => {
                let obj = {
                  ...item,
                  id: item.id,
                  title: item.title,
                  assetsId: item.assetsId,
                  prizeType: item.prizeType,
                  logo: item.logo,
                  discount: item.price || item.singleAmount,
                  singleAmount: item.singleAmount,
                  price: item.price,
                  prizeCount: item.totalAmount,
                  minNum: item.totalAmount,
                  orderAmtLimit: item.orderAmtLimit,
                  itemTotalLimit: item.itemTotalLimit,
                };
                if (item.prizeType == 1) {
                  obj.quota = item.quota;
                  obj.couponType = item.couponType;
                }
                if (item.prizeType == 3){
                  obj.addressFillEndTime = item.addressFillEndTime
                  obj.predictSendTime = item.predictSendTime
                  obj.isFollowActivityEndTime = item.isFollowActivityEndTime
                  obj.shouldCollectExtraData = item.shouldCollectExtraData;
                  obj.extraQuestion = item.extraQuestion;
                  obj.addressFillLimit = item.addressFillLimit
                  // 提交地址限制回显：逗号分隔字符串转数字数组
                  if (item.commitAddressLimit) {
                    obj.commitAddressLimit = typeof item.commitAddressLimit === 'string'
                      ? item.commitAddressLimit.split(',').map(Number)
                      : item.commitAddressLimit
                  } else {
                    obj.commitAddressLimit = [0]
                  }
                }
                if (item.prizeType == 3 && item.isGoodManage == 1) {
                  obj.isGoodManage = item.isGoodManage;
                }
                if (item.prizeType == 14) {
                  obj.pointActivityPrizeRemark = item.pointActivityPrizeRemark;
                  obj.isGoodManage = item.isGoodManage||0;
                }
                return obj;
              }
            ): [];
          } else {
            tableData = res.data.pointActivityPrizeDTOList ? res.data.pointActivityPrizeDTOList.map(
              (item, index) => {
                let obj = {
                  ...item,
                  id: item.id,
                  title: item.title,
                  assetsId: item.assetsId,
                  prizeType: item.prizeType,
                  logo: item.logo,
                  discount: item.price || item.singleAmount,
                  singleAmount: item.singleAmount,
                  price: item.price,
                  prizeCount: item.totalAmount,
                  minNum: item.totalAmount,
                };
                if (item.prizeType == 3){
                  obj.addressFillEndTime = item.addressFillEndTime
                  obj.predictSendTime = item.predictSendTime
                  obj.isFollowActivityEndTime = item.isFollowActivityEndTime
                  obj.shouldCollectExtraData = item.shouldCollectExtraData;
                  obj.extraQuestion = item.extraQuestion;
                  obj.addressFillLimit = item.addressFillLimit
                  // 提交地址限制回显：逗号分隔字符串转数字数组
                  if (item.commitAddressLimit) {
                    obj.commitAddressLimit = typeof item.commitAddressLimit === 'string'
                      ? item.commitAddressLimit.split(',').map(Number)
                      : item.commitAddressLimit
                  } else {
                    obj.commitAddressLimit = [0]
                  }
                }
                if (item.prizeType == 1) {
                  obj.quota = item.quota;
                  obj.couponType = item.couponType;
                }
                if (item.prizeType == 3 && item.isGoodManage == 1) {
                  obj.isGoodManage = item.isGoodManage;
                }
                if (item.prizeType == 14) {
                  obj.pointActivityPrizeRemark = item.pointActivityPrizeRemark;
                  obj.isGoodManage = item.isGoodManage||0;
                }
                return obj;
              }
            ) : [];
          }
        if (!this.activityData.isCopy) {
          this.ruleForm.radio = res.data.priceType; // 0：显示京东价 1：显示促销价 ,
          // 兼容草稿箱
          if (
            res.data.pointActivityPrizeDTOList &&
            res.data.pointActivityPrizeDTOList.length
          ) {
            if (res.data.ruleDto.prizeSettingType == 1) {
              this.ladderData = ladderData;
            } else {
              this.tableData = tableData;
            }
          }
          // 指定购买商品
          if (res.data.ruleDto.filterType == 1) {
            this.itemListForFilter =
              res.data.ruleDto.itemList && res.data.ruleDto.itemList.length
                ? res.data.ruleDto.itemList
                : [];
            this.includeArr = this.itemListForFilter;
            this.selectGoodsFilterArr = this.itemListForFilter;
          } else if (res.data.ruleDto.filterType == 2) {
            this.itemListForFilter =
              res.data.ruleDto.itemList && res.data.ruleDto.itemList.length
                ? res.data.ruleDto.itemList
                : [];
            this.excludeArr = this.itemListForFilter;
            this.selectGoodsFilterArr = this.itemListForFilter;
          }
          //曝光商品
          this.ruleForm.exposureSwitch =
            res.data.isExposureItem == 0 ? false : true;
          this.selectGoodsArr = res.data.itemList;
          // this.mainImagelist = res.data.itemList;
          this.itemListFor = res.data.itemList;
          // 规则
          this.ruleForm.activityRulesText = String(res.data.ruleDescription); //生成规则
        } else {
          if (res.data.ruleDto.prizeSettingType == 1) {
            if(ladderData.some((item)=>item.prizeType == 3)) {
              this.ladderData = ladderData.filter((item) => item.prizeType == 3)
              this.ladderData.forEach((it)=>delete it.id);
            } else {
              this.ladderData = [{
                orderAmtLimit: "", //订单门槛orderAmtLimit
                itemTotalLimit: "", //商品件数门槛itemTotalLimit
                peopleCount: "",
                prizeType: "",
                discount: "",
                prizeCount: "",
                singleAmount: "",
              },
              {
                orderAmtLimit: "", //订单门槛
                itemTotalLimit: "", //商品件数门槛
                peopleCount: "",
                prizeType: "",
                discount: "",
                prizeCount: "",
                singleAmount: "",
              }]
            }
          } else {
            if(tableData.some((item)=>item.prizeType == 3)) {
              this.tableData = tableData.filter((item) => item.prizeType == 3)
              this.tableData.forEach((it)=>delete it.id);
            } else {
              this.tableData = [{
                peopleCount: "",
                prizeType: "",
                discount: "",
                prizeCount: "",
                singleAmount: "",
              }]
            }
        
          }
        }
        this.hdTaskTemplateGroup();
        this.activityTimeChange();
      });
    },
    colseDialog() {
      this.showDialog = false;
      this.clickActual = false;
    },
    //会员等级
    getLevel() {
      querymemberLevel()
        .then((res) => {
          console.log(res, 6667);
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
          console.log(this.levelList, 111112);
        })
        .catch((res) => {});
    },
    getCodeIMG() {
      // const data = await prefixurl();
      const codeImg = document.querySelectorAll(".qrCodeIMG");
      // const url = `${this.activityData.telCode}/clientPreview?activityType=${this.activityData.id}&venderId=${data.data.venderId}`;
      for (let index = 0; index < codeImg.length; index++) {
        const elementbox = codeImg[index];
        elementbox.innerHTML = "";
      }
      let url = `${this.telCode}&activityType=${this.activityData.id}&templateJson=`;
      const arr = [1, 8, 16, 17, 18, 19, 27, 28];
      if (arr.includes(Number(this.activityData.id))) {
        url = "https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=";
      }
      // const codeImg = this.$refs[queryIdIMG];
      for (let index = 0; index < codeImg.length; index++) {
        const element = codeImg[index];
        new QRCode(element, {
          width: 140, // 设置宽度，单位像素
          height: 140, // 设置高度，单位像素
          // text: url, // 设置二维码内容或跳转地址
          text:
            url +
            (arr.includes(Number(this.activityData.id))
              ? this.giftList[index].secondImageUrl
              : JSON.stringify({
                  templateUItype: this.giftList[index].templateUItype,
                })),
        });
      }
    },
    //生成二维码
    qrcodeAll(val, queryId) {
      this.qrcode = new QRCode(queryId, {
        width: 117, // 设置宽度，单位像素
        height: 117, // 设置高度，单位像素
        text: val, // 设置二维码内容或跳转地址
      });
    },

    //清空商品数据
    deleteCoupon() {
      this.prizeSettingList.price = null;
      this.prizeSettingList.title = "";
      this.prizeSettingList.assetsId = null;
      this.prizeSettingList.prizeType = null;
    },
    itemDel(index) {
      if (this.tableData.length == 1) {
        this.$message.warning("必须有一个奖项");
        return;
      }
      this.tableData.splice(index, 1);
    },
    addPrizeRule() {
      if (this.tableData.length === 4) {
        this.$message.warning("最多可设置4个奖项");
        return;
      }
      this.tableData.push({
        peopleCount: "",
        prizeType: "",
        value: "",
        prizeCount: "",
      });
    },
    addLadderRule() {
      if (this.ladderData.length === 4) {
        this.$message.warning("最多可设置4个阶梯");
        return;
      }
      this.ladderData.push(
        {
          orderAmtLimit: "", //订单门槛orderAmtLimit
          itemTotalLimit: "", //商品件数门槛itemTotalLimit
          peopleCount: "",
          prizeType: "",
          discount: "",
          prizeCount: "",
          singleAmount: "",
        },
      );
    },
    itemDelTable(index) {
      if (this.tableData.length == 1) {
        this.$message.warning("必须有一个奖品");
        return;
      }
      this.tableData.splice(index, 1);
    },
    itemDelLadder(index) {
      if (this.ladderData.length == 2) {
        this.$message.warning("必须有两个阶梯");
        return;
      }
      this.ladderData.splice(index, 1);
    },
    //选择商品数据 曝光
    getTheData(data, prizeType) {
      this.showDialog = false;
      if (this.ruleForm.prizeSettingType == "1") {
        this.ladderData[this.ladderIndex].prizeType = prizeType;
        this.ladderData[this.ladderIndex].price =
          data.discount || data.singleAmount;
        this.ladderData[this.ladderIndex].singleAmount = data.singleAmount;
        this.ladderData[this.ladderIndex].title = data.name || prizeType;
        this.ladderData[this.ladderIndex].assetsId = Number(data.couponId || data.skuId);
        this.ladderData[this.ladderIndex].logo = data.logo;
        if (prizeType == 1) {
          this.ladderData[this.ladderIndex].quota = data.quota;
          this.ladderData[this.ladderIndex].couponType = data.couponType;
        }
        if (prizeType == 2) {
          this.ladderData[this.ladderIndex].quantityTotal = data.quantityTotal;
        }
        if (prizeType == 3) {
          this.ladderData[this.ladderIndex].addressFillEndTime = data.addressFillEndTime
          this.ladderData[this.ladderIndex].predictSendTime = data.predictSendTime
          this.ladderData[this.ladderIndex].isFollowActivityEndTime = data.isFollowActivityEndTime
          this.ladderData[this.ladderIndex].shouldCollectExtraData = data.shouldCollectExtraData;
          this.ladderData[this.ladderIndex].extraQuestion = data.extraQuestion;
          this.ladderData[this.ladderIndex].addressFillLimit = data.addressFillLimit
          this.ladderData[this.ladderIndex].commitAddressLimit = data.commitAddressLimit
          if (!data.isGoodManage) {
            this.ladderData[this.ladderIndex].skuId = data.skuId;
            delete this.ladderData[this.ladderIndex].isGoodManage;
          } else {
            this.ladderData[this.ladderIndex].isGoodManage = data.isGoodManage;
          }
        }
        if(prizeType == 4){
          this.ladderData[this.ladderIndex].title = data.discount + "店铺积分";
        }
        // 实物随单发
        if(prizeType == 14 || prizeType == 1) {
          this.getPhysicalShipped(this.ladderData[this.ladderIndex],prizeType,data);
        }
        // 金豆、E卡、爱奇艺、PLUS、红包计划需要剩余份额
        if ([2, 5, 6, 7, 8, 10].includes(Number(prizeType))) {
          this.ladderData[this.ladderIndex].budgetRemain = data.budgetRemain;
        }
        if (prizeType == 3 && data.isGoodManage) {
          this.ladderData[this.ladderIndex].budgetRemain = data.budgetRemain;
        }
      } else {
        this.tableData[this.tableIndex].prizeType = prizeType;
        this.tableData[this.tableIndex].price =
          data.discount || data.singleAmount;
        this.tableData[this.tableIndex].singleAmount = data.singleAmount;
        this.tableData[this.tableIndex].title = data.name || prizeType;
        this.tableData[this.tableIndex].assetsId = Number(data.couponId || data.skuId);
        this.tableData[this.tableIndex].logo = data.logo;
        if (prizeType == 1) {
          this.tableData[this.tableIndex].quota = data.quota;
          this.tableData[this.tableIndex].couponType = data.couponType;
        }
        if (prizeType == 2) {
          this.tableData[this.tableIndex].quantityTotal = data.quantityTotal;
        }
        if (prizeType == 3) {
          this.tableData[this.tableIndex].addressFillEndTime = data.addressFillEndTime
          this.tableData[this.tableIndex].predictSendTime = data.predictSendTime
          this.tableData[this.tableIndex].isFollowActivityEndTime = data.isFollowActivityEndTime
          this.tableData[this.tableIndex].shouldCollectExtraData = data.shouldCollectExtraData;
          this.tableData[this.tableIndex].extraQuestion = data.extraQuestion;
          this.tableData[this.tableIndex].addressFillLimit = data.addressFillLimit
          this.tableData[this.tableIndex].commitAddressLimit = data.commitAddressLimit
          if (!data.isGoodManage) {
            this.tableData[this.tableIndex].skuId = data.skuId;
            delete this.tableData[this.tableIndex].isGoodManage;
          } else {
            this.tableData[this.tableIndex].isGoodManage = data.isGoodManage;
          }
        }
        if(prizeType == 4){
          this.tableData[this.tableIndex].title = data.discount + "店铺积分";
        }
        // 实物随单发
        if(prizeType == 14 || prizeType == 1) {
          this.getPhysicalShipped(this.tableData[this.tableIndex],prizeType,data);
        }
        // 金豆、E卡、爱奇艺、PLUS、红包计划需要剩余份额
        if ([2, 5, 6, 7, 8, 10].includes(Number(prizeType))) {
          this.tableData[this.tableIndex].budgetRemain = data.budgetRemain;
        }
        if (prizeType == 3 && data.isGoodManage) {
          this.tableData[this.tableIndex].budgetRemain = data.budgetRemain;
        }
      }
      this.$refs.updateRef.update()
    },

    //模板下一步
    nextStep() {
      this.localStepNum = this.activityData.id;
      this.localStep = 1;
      this.$emit("titopName", this.activityData.name, true);
    },
    //开卡礼包
    nextStepKai(items, templateId = 0) {
      //新增判断
      if (this.orderCRM) {
        return this.$message.warning(
          "自营店铺需要搭配云短信CRM使用！请联系客服！"
        );
      } else {
        this.localStepNum = this.activityData.id;
        this.localStep = 1;
        this.templateUItype = items.templateUItype;
        this.rgb = items.rgb;
        this.rgb2 = items.rgb2;
        this.rgb3 = items.rgb3;
        this.previewUrl = items.url;
        this.previewNoTextUrl = items.url3;
        this.customerPaperwork.titleColor = items.rgb3;
        this.customerPaperwork.descColor = items.rgb2;
        this.yAxis = Number(items.yAxis);
        if (templateId) {
          this.templateId = templateId;
        }
        this.$emit("titopName", this.activityData.name, true);
      }
    },
    //时间
    clearTime(a, b) {
      this.ruleForm.activityStartTime = "";
      this.ruleForm.activityEndTime = "";
    },
    // 复购规则时间清空
    clearReOrderTime() {
      this.ruleForm.orderFinishStartTime = '';
      this.ruleForm.orderFinishEndTime = '';
    },
    clearOrderTime() {
      this.ruleForm.orderStartTime = null;
      this.ruleForm.orderEndTime = null;
    },
    //删除
    delec(index) {
      // this.mainImagelist.splice(index, 1);
      this.itemListFor.splice(index, 1);
      // console.log(this.selectGoodsArr, 4444444);
    },
    //完善信息删除
    deleteaInfo(index) {
      this.itemArrOne.splice(index, 1);
    },
    //图片拖拽
    onEnd() {
      this.isDragging = false;
      //拖拽完成后的顺序
      let arr = [];
      this.mainImagelist.forEach((item) => {
        // arr.push(item.wareId);
        arr.push(item.skuId);
        this.draggingId = arr;
      });
    },
    //商品回调
    selectGoodsChange(val) {
      this.goodsState = false;
    },
    centerVis(scope) {
      if (this.isStart) return;
      this.itemArr = this.tableData;
      this.tableIndex = scope.$index;
      this.JingdouCount.prizeCount = scope.row.prizeCount;
      if (this.tableData[scope.$index].prizeType == 3) {
        this.clickActual = true;
      }
      this.echoDate = scope.row;
      this.showDialog = true;
      this.$nextTick(() => {
        this.$refs.selectProduct.openDialog();
      });
    },
    centerVis2(scope) {
      if (this.isStart) return;
      this.itemArr = this.ladderData;
      this.ladderIndex = scope.$index;
      this.JingdouCount.prizeCount = scope.row.prizeCount;
      if (this.ladderData[scope.$index].prizeType == 3) {
        this.clickActual = true;
      }
      this.echoDate = scope.row;
      this.showDialog = true;
      this.$nextTick(() => {
        this.$refs.selectProduct.openDialog();
      });
    },
    //连续签到送积分
    signInpoints(val) {
      this.ruleForm.singScore = val;
    },
    //连续签到删除
    deletea(index) {
      this.itemArr.splice(index, 1);
    },
    //添加条件
    addCondition() {
      let parm = {
        continueSignPoints: this.itemArr.continueSignPoints,
        days: this.itemArr.days,
      };
      this.ele++;
      this.ele = parm;
      this.itemArr.push(this.ele);
    },
    //完善信息的添加
    perfectAdd() {
      let valueParm = {
        informationmation: this.itemArrOne.informationmation,
        informationmationOne: this.itemArrOne.informationmationOne,
      };
      this.element++;
      this.element = valueParm;
      this.itemArrOne.push(this.element);
    },
    //奖品设置
    prizeSetChange(val) {
      if (val == true) {
        this.limit = false;
      } else {
        this.limit = true;
        this.ruleForm.inputprize = "";
      }
    },
    //活动时间驱动
    activityTimeChange(val) {
      // this.ruleForm.activityStartTime = this.activityTimeValue[0];
      // this.ruleForm.activityEndTime = this.activityTimeValue[1];
      let nowTime = new Date().getTime();
      let start = new Date(this.ruleForm.activityStartTime).valueOf();
      let end = new Date(this.ruleForm.activityEndTime).valueOf();
      let CRMtime = new Date(this.orderCRMtime).valueOf();
      let invalidateDate = new Date(
        this.$store.getters.loginUserInfo.expiresIn
      ).valueOf();

      var datas, change1, change2, days, daysStart, daysEnd, date3;
      // daysStart = this.ruleForm.activityStartTime && this.ruleForm.activityStartTime.substring(0, 10);
      // daysEnd = this.ruleForm.activityEndTime && this.ruleForm.activityEndTime.substring(0, 10);
      if (this.ruleForm.activityEndTime && this.ruleForm.activityStartTime) {
        // datas = daysEnd.split("-");
        // change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        // datas = daysStart.split("-");
        // change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        // days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);
        // this.timeDay = days;

        // 更换组件后需要更换时间计算方法
        this.timeDay = Math.floor(
          Math.abs(
            new Date(this.ruleForm.activityEndTime) -
              new Date(this.ruleForm.activityStartTime)
          ) /
            1000 /
            60 /
            60 /
            24
        );

        //计算小时
        date3 =
          new Date(this.ruleForm.activityEndTime).getTime() -
          new Date(this.ruleForm.activityStartTime).getTime();
        var leave1 = date3 % (24 * 3600 * 1000);
        this.timeOut = Math.floor(leave1 / (3600 * 1000));
      } else {
        this.timeOut = 0;
      }

      if (this.backgroundOpacity) return;
      if (end > invalidateDate) {
        this.$message.warning("活动时间不可超过互动数据授权有效期！");
        // this.activityTimeValue[1] = "";
        this.ruleForm.activityEndTime = "";
        return;
      }
      if (end > CRMtime && this.venderType && CRMtime && end) {
        this.$message.warning("活动有效期不可超过【云短信CRM】订购有效期。");
        // this.activityTimeValue[1] = "";
        this.ruleForm.activityEndTime = "";
        return;
      }
      if ((start - nowTime) / 1000 / 60 < 5) {
        if (this.activeValue) {
          this.disableTime = true;
        }
      }
      if (end < nowTime && end) {
        this.$message.warning("结束时间不能小于当前时间");
        return;
      }
      if (end < start && start && end) {
        this.$message.warning("结束时间不能小于开始时间");
        return;
      }
    },
    // 下单时间
    orderChange() {
      let start = new Date(this.ruleForm.orderStartTime).valueOf();
      let end = new Date(this.ruleForm.orderEndTime).valueOf();
      var datas, change1, change2, days, daysStart, daysEnd, date3;
      daysStart =
        this.ruleForm.orderStartTime &&
        this.ruleForm.orderStartTime.substring(0, 10);
      daysEnd =
        this.ruleForm.orderEndTime &&
        this.ruleForm.orderEndTime.substring(0, 10);
      if (this.ruleForm.orderStartTime && this.ruleForm.orderEndTime) {
        datas = daysEnd.split("-");
        change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        datas = daysStart.split("-");
        change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);

        if (days > 365) {
          this.$message.warning("下单时间最大范围为近1年");
          this.ruleForm.orderEndTime = null;
          return;
        }
      }
      if (start > end && start && end) {
        this.$message.warning("下单开始时间不能大于下单结束时间");
        this.ruleForm.activityEndTime = null;
        return;
      }
    },
    // 点击下单时间显示提示
    orderFocus(type) {
      if (this.isStart) {
        if (type == 1) {
          this.isShowEndTip = true;
        } else {
          this.isShowTip = true;
        }
      }
    },
    // 规则判断
    changDays() {
      if (Number(this.ruleForm.days) > 100) {
        this.$message.warning("范围为1-100天!");
        this.ruleForm.days = "";
      }
      if (
        this.ruleForm.orderStartCount &&
        this.ruleForm.orderEndCount &&
        Number(this.ruleForm.orderStartCount) >=
          Number(this.ruleForm.orderEndCount)
      ) {
        this.$message.warning("商品结束件数要大于商品开始件数!");
        this.ruleForm.orderEndCount = "";
      }
      if (
        this.ruleForm.orderStartPayment &&
        this.ruleForm.orderEndPayment &&
        Number(this.ruleForm.orderStartPayment) >=
          Number(this.ruleForm.orderEndPayment)
      ) {
        this.$message.warning("订单结束金额要大于订单开始金额!");
        this.ruleForm.orderEndPayment = "";
      }
    },
    skuPaymentChange() {
      if (
        this.ruleForm.skuStartPayment &&
        this.ruleForm.skuEndPayment &&
        Number(this.ruleForm.skuStartPayment) >=
          Number(this.ruleForm.skuEndPayment)
      ) {
        this.$message.warning("指定商品结束金额要大于指定商品开始金额！");
        this.ruleForm.skuEndPayment = "";
      }
    },
    // 返回上一步
    returnBack() {
      // this.$emit("returnBack");
      if (this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      if (this.localStep == 0) this.$emit("returnBack");
      if (this.localStep == 1) this.localStep = 0;
    },
    // 取消编辑
    cancelEdit() {
      this.$emit("cancelEdit");
    },
    //保存编辑
    saveEdit() {
      // console.log(this.itemArrOne);
      //新增进店设置校验
      if (this.ruleForm.goShopSetting == 1 && !this.ruleForm.goShopAppId) {
        this.$message.warning("请输入小程序appId");
        return;
      }
      if (this.ruleForm.goShopSetting == 2) {
        if (!this.ruleForm.goShopUrl) {
          this.$message.warning("请输入指定链接");
          return;
        } else if (
          !this.ruleForm.goShopUrl.startsWith("https://") ||
          !this.ruleForm.goShopUrl.includes("jd.com")
        ) {
          this.$message.warning(
            "输入的内容非链接或为接口无法支持的链接，请重新设置"
          );
          return;
        }
      }
      let flag = false;
      this.ladderData.some((item) => {
        if (!item.orderAmtLimit) {
          flag = true;
        }
      });
      if (flag && this.ruleForm.prizeSettingType == 1) {
        return this.$message.warning("请输入阶梯的订单金额");
      }
      // 公活动配置校验
      if (!useValidateMoreActSet(this)) {
        return;
      }
      if(this.placementPosition.length==0) {    
        this.$message.warning("请选择活动投放位置！");
        return
      }
      this.joinBlackList = true;
    },
    // 保存草稿
    saveDraft() {
      //活动名称的限制
      if (
        !this.ruleForm.activityName ||
        this.ruleForm.activityName.length == 0
      ) {
        this.$message.warning("请输入活动名称");
        return;
      }
      if (this.isDraftEdit) {
        this.$confirm("是否保存对当前草稿的修改?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      } else {
        this.$confirm("是否存为草稿?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      }
    },
    //弹框确认
    async handleDialogCloseAnoth() {
      let cardParams = {
        activityName: this.ruleForm.activityName, //活动名称
        startTime: this.ruleForm.startTime,
        endTime: this.ruleForm.endTime,
        isExposureItem: this.ruleForm.exposureSwitch ? 1 : 0, //是否添加曝光商品 0 否 1 是
        priceType: this.ruleForm.radio, //  0：显示京东价 1：显示促销
        ruleDescription: this.ruleForm.activityRulesText, //规则说明
        allowLevel: this.ruleForm.partner.join(","), //参与会员等级：-1(全部)，0(非会员)，其余填会员等级,
        // 1.4迭代 这里提交

        ruleDTO: {
          cusTemplateJSON:this.cusTemplateJSON,
          isForceRemind:this.isForceRemind,
          isCheckOpenCardTime:
            this.actMember == 2 ? this.ruleDto.isCheckOpenCardTime : false,
          openCardStartTime:
            this.actMember == 2 ? this.ruleDto.openCardStartTime : "",
          openCardEndTime:
            this.actMember == 2 ? this.ruleDto.openCardEndTime : "",
          plusObject: this.ruleDto.plusObject, //plus会员
          popOrderStartPaymentType: this.ruleForm.popOrderStartPaymentType,
          mergeOrder: this.ruleForm.mergeOrder,
          subType: this.activityData.id, //活动类型  16: 下单有礼 17: 首单专享礼 18:复购有礼
          condFollow: this.ruleForm.condFollow ? 1 : 0, //是否需要关注店铺
          openCardFollow: this.ruleForm.openCardFollow,
          firstOpenCardTimeType: this.ruleForm.firstOpenCardTimeType,
          openCardBeforeDay: this.ruleForm.openCardBeforeDay,
          joinType: this.ruleForm.joinType || 0,
          sendType: this.ruleDto.sendType, //奖品发放形式：0立即发放，1确认收货后发放，2活动结束后发放
          sendDay: this.ruleDto.sendDay, //发放天数，当sendType为1或2时有效
          orderFinishStartTime: this.ruleForm.joinType == 2 ? this.ruleForm.orderFinishStartTime : '', // 复购规则-开始时间
          orderFinishEndTime: this.ruleForm.joinType == 2 ? this.ruleForm.orderFinishEndTime : '', // 复购规则-结束时间
          days: this.ruleForm.days, //近X天内未购
          orderStartTime: this.ruleForm.orderStartTime,
          orderEndTime: this.ruleForm.orderEndTime,
          orderStartCount: this.ruleForm.orderStartCount,
          orderEndCount: this.ruleForm.orderEndCount,
          orderStartPayment: this.ruleForm.orderStartPayment,
          orderEndPayment: this.ruleForm.orderEndPayment,
          filterType: this.ruleForm.filterType,
          skuIdList: this.itemListForFilter.map((item) => item.skuId),
          shareTitle: this.ruleForm.shareTitle,
          shareIntroduce: this.ruleForm.shareIntroduce,
          sharePic: this.ruleForm.sharePic,
          prizeSettingType: this.ruleForm.prizeSettingType,
          prizeShowType: this.ladder.prizeShowType,
          orderCountType: this.ladder.orderCountType,

          goShopSetting: this.ruleForm.goShopSetting,
          goShopAppId: this.ruleForm.goShopAppId,
          goShopUrl: this.ruleForm.goShopUrl,
          isSupportOrderList: this.ruleForm.isSupportOrderList,
          supportRollback: this.ruleForm.supportRollback, //是否支持奖品撤回
          supportCancelOrderRebind: this.ruleForm.supportCancelOrderRebind, //是否支持订单取消后可重新绑定其他订单领取奖品
          paperworkType: this.ruleForm.paperworkType,
          customerPaperwork: JSON.stringify(this.customerPaperwork),
          sellerSkuList: this.ruleDto.sellerSkuList || [],
          venderIds: this.ruleDto.venderIds || [],
          multiShopSkuType: this.ruleDto.multiShopSkuType,
          skuBelongVenderId: this.ruleDto.multiShopSkuType == '0' ? this.itemListFor[0] && this.itemListFor[0].belongVenderId : this.venderId || "",
        }, //活动名称
        pointActivityPrizeDTOList: [], // 奖品
        itemList: this.itemListFor, //曝光商品集合
        points: 10,
        templateId: this.templateId,
        isKeyActivity: this.isKeyActivity,
        placementPosition: this.placementPosition.join(","),
        isValidBlackList: this.ruleForm.isValidBlackList,
        studentStatus: this.ruleForm.studentStatus,
      };
      this.$set(cardParams.ruleDTO, 'filterSkuType', this.ruleDto.filterSkuType);
      if (this.activityData.id === 17) {
        // 首单专享礼规则
        cardParams.ruleDTO.firstBuyRule = this.ruleForm.firstBuyRule;
        cardParams.ruleDTO.lockPrizeType = this.ruleForm.lockPrizeType; //锁定奖品类型
        cardParams.ruleDTO.lockPrizeDay = this.ruleForm.lockPrizeDay; //锁定奖品时间
      }
      if (this.activityData.id == 18 && this.ruleForm.joinType == 0) {
        cardParams.ruleDTO.days = "";
      }
      if (this.actMember == 1) {
        cardParams.allowLevel = "-1";
      } else if (this.actMember == 3) {
        cardParams.allowLevel = "99";
        cardParams.crowdIds = this.peopleSelected.join(",");
      } else if (this.actMember == 2) {
        cardParams.allowLevel = this.ruleForm.partner.join(",");
        if (cardParams.allowLevel == "-1") {
          //会员等级设置
          let list = ["-1", "0"];
          this.levelList.forEach((item, index) => {
            let num = index + 1;
            list.push(num);
          });
          cardParams.allowLevel = list.join(",");
        }
      }
      if (this.isNongfu) {
        cardParams.ruleDTO.isLimitSkuAmt = this.ruleForm.isLimitSkuAmt;
        cardParams.ruleDTO.skuStartPayment = this.ruleForm.skuStartPayment;
        cardParams.ruleDTO.skuEndPayment = this.ruleForm.skuEndPayment;
        if (
          !this.isDraft &&
          this.ruleForm.isLimitSkuAmt &&
          !this.appointGoodsFilterArr.length
        ) {
          return this.$message.error("请选择条件二的指定商品");
        }
        if (this.appointGoodsFilterArr.length) {
          cardParams.ruleDTO.limitSkuIds = this.appointGoodsFilterArr.map(
            (item) => item.skuId
          );
        }
      }
      if (this.ruleForm.prizeSettingType == "1") {
        cardParams.pointActivityPrizeDTOList = this.ladderData.map((item) => {
          let prize = {
            ...item,
            id: item.id,
            title: item.title,
            assetsId: item.assetsId,
            prizeType: item.prizeType,
            singleAmount: item.singleAmount, //
            totalAmount: item.prizeCount, // 总数额
            price: item.price,
            orderAmtLimit: item.orderAmtLimit,
            itemTotalLimit: item.itemTotalLimit,
          };
          if (prize.prizeType == 3 || prize.prizeType == 10) {
            prize.addressFillEndTime = item.addressFillEndTime
            prize.predictSendTime = item.predictSendTime
            prize.isFollowActivityEndTime = item.isFollowActivityEndTime
            prize.shouldCollectExtraData = item.shouldCollectExtraData;
            prize.extraQuestion = item.extraQuestion;
            prize.addressFillLimit = item.addressFillLimit
            // 提交地址限制：数组转逗号分隔字符串
            prize.commitAddressLimit = Array.isArray(item.commitAddressLimit) 
              ? item.commitAddressLimit.join(',') 
              : item.commitAddressLimit
            prize.logo = item.logo;
            prize.assetsId = item.skuId || item.assetsId;
            if (item.isGoodManage == 1) {
              prize.isGoodManage = item.isGoodManage;
            }
          }
          if (prize.prizeType == 1) {
            prize.quota = item.quota;
            prize.couponType = item.couponType;
          }

          if (prize.prizeType == 2 || prize.prizeType == 4) {
            prize.singleAmount = item.price;
            prize.logo = item.logo || ''; // 为prizeType为2时添加logo字段
          } else {
            prize.singleAmount = 1;
          }
          if (prize.prizeType == 12) {
            prize.logo = item.logo;
          }
          if(item.prizeType == 14 || item.prizeType == 1) {
            prize.logo = item.logo;
            this.getPhysicalShipped(prize,item.prizeType,item);
          }
          return prize;
        });
      } else {
        cardParams.pointActivityPrizeDTOList = this.tableData.map((item) => {
          let prize = {
            ...item,
            id: item.id,
            title: item.title,
            assetsId: item.assetsId,
            prizeType: item.prizeType,
            singleAmount: item.singleAmount, //
            totalAmount: item.prizeCount, // 总数额
            price: item.price,
          };
          if (prize.prizeType == 3 || prize.prizeType == 10) {
            prize.addressFillEndTime = item.addressFillEndTime
            prize.predictSendTime = item.predictSendTime
            prize.isFollowActivityEndTime = item.isFollowActivityEndTime
            prize.shouldCollectExtraData = item.shouldCollectExtraData;
            prize.extraQuestion = item.extraQuestion;
            prize.addressFillLimit = item.addressFillLimit
            // 提交地址限制：数组转逗号分隔字符串
            prize.commitAddressLimit = Array.isArray(item.commitAddressLimit) 
              ? item.commitAddressLimit.join(',') 
              : item.commitAddressLimit
            prize.logo = item.logo;
            prize.assetsId = item.skuId || item.assetsId;
            if (item.isGoodManage == 1) {
              prize.isGoodManage = item.isGoodManage;
            }
          }
          if (prize.prizeType == 1) {
            prize.quota = item.quota;
            prize.couponType = item.couponType;
          }

          if (prize.prizeType == 2 || prize.prizeType == 4) {
            prize.singleAmount = item.price;
            prize.logo = item.logo || ''; // 为prizeType为2时添加logo字段
          } else {
            prize.singleAmount = 1;
          }
          if (prize.prizeType == 12) {
            prize.logo = item.logo;
          }
          if(item.prizeType == 14 || item.prizeType == 1) {
            prize.logo = item.logo;
            this.getPhysicalShipped(prize,item.prizeType,item);
          }
          return prize;
        });
      }
      //对象排序(根据对象的某一属性)
      if (this.draggingId.length != []) {
        let a = this.draggingId;
        let b = [];
        for (let i = 0; i < a.length; i++) {
          this.itemListFor.find((obj) => {
            if (obj.skuId == a[i]) {
              b.push({
                logo: obj.logo,
                price: obj.price,
                title: obj.title,
                skuId: obj.skuId,
              });
            }
          });
        }
        cardParams.itemList = b;
      }

      if (!this.isDraft) {
        //活动名称的限制
        if (
          !this.ruleForm.activityName ||
          this.ruleForm.activityName.length == 0
        ) {
          this.$message.warning("请输入活动名称");
          return;
        }
        //活动时间的限制
        if (
          !this.ruleForm.activityStartTime ||
          !this.ruleForm.activityEndTime
        ) {
          this.$message.warning("请输入活动时间");
          return;
        }
        let nowTime = new Date().getTime();
        let end = new Date(this.ruleForm.activityEndTime).valueOf();
        if (end < nowTime) {
          this.$message.warning("结束时间不能小于当前时间");
          return;
        }
        if (this.actMember == 3 && !this.peopleSelected.length) {
          this.$message.warning("请选择指定人群");
          return;
        }
        // 1.14迭代 这里判断
        // if (this.actMember == "2") {
        //   if (
        //     this.ruleDto.isCheckOpenCardTime &&
        //     (!this.ruleDto.openCardStartTime || !this.ruleDto.openCardEndTime)
        //   ) {
        //     return this.$message.warning("请选择入会时间");
        //   }
        // }
        if (this.actMember == "2") {
          if (
            this.ruleForm.firstOpenCardTimeType == 1 &&
            (!this.ruleForm.openCardBeforeDay)
          ) {
            return this.$message.warning("请完善首次入会时间");
          }
          if (
            this.ruleForm.firstOpenCardTimeType == 2 &&
            (!this.ruleDto.openCardStartTime || !this.ruleDto.openCardEndTime)
          ) {
            return this.$message.warning("请完善首次入会时间");
          }
        }
        
        //复购规则不能为空
        // if (this.activityData.id != 16) {
        //   if (!this.ruleForm.days) {
        //     this.$message.warning(
        //       `${this.activityData.id == 17 ? "首单专享礼" : "复购"}规则不能为空`
        //     );
        //     return;
        //   }
        // }

        if (this.activityData.id == 17 && !this.ruleForm.days) {
          this.$message.warning("首单专享礼规则不能为空");
          return;
        }

        if (this.activityData.id == 18 && this.ruleForm.joinType == 1) {
          if (!this.ruleForm.days || this.ruleForm.days == "") {
            this.$message.warning("复购规则不能为空");
            return;
          }
          if (this.ruleForm.days <= 0 || this.ruleForm.days > 180) {
            this.$message.warning("回购天数需要在1-180天内");
            return;
          }
        }

        //下单时间不能为空
        if (!this.ruleForm.orderStartTime || !this.ruleForm.orderEndTime) {
          this.$message.warning("请填写下单时间！");
          return;
        }
        //商品件数不能为空 1.14迭代取消商品限制
        // if (!String(this.ruleForm.orderStartCount)) {
        //   this.$message.warning("请填写商品件数");
        //   return;
        // }
        //订单金额不能为空
        // if (!String(this.ruleForm.orderStartPayment)) {
        //   this.$message.warning("请填写订单金额");
        //   return;
        // }
        // 指定金额不能为空
        if (
          this.isNongfu &&
          this.ruleForm.isLimitSkuAmt &&
          !String(this.ruleForm.skuStartPayment)
        ) {
          this.$message.warning("请填写指定商品开始金额");
          return;
        }
        if (this.ruleForm.filterType != 0) {
          console.log(this.ruleDto.sellerSkuList);
          let isFlay = false;
          this.ruleDto.sellerSkuList.forEach((item) => {
            if (item.skuIds.length == 0) {
              isFlay = true;
            }
          })
          if (isFlay) {
            this.$message.warning(`请添加${this.ruleForm.filterType == 1 ? '指定' : '排除'}商品！`);
            return;
          }
        }
        // if (this.ruleForm.filterType == 1) {
        //   if (this.itemListForFilter.length == 0) {
        //     this.$message.warning("请添加指定商品！");
        //     return;
        //   }
        // } else if (this.ruleForm.filterType == 2) {
        //   if (this.itemListForFilter.length == 0) {
        //     this.$message.warning("请添加排除商品！");
        //     return;
        //   }
        // }
        if (this.ruleForm.prizeSettingType == "1") {
          //奖品设置最少一项
          if (this.ladderData.length === 0) {
            this.$message.warning("奖品设置最少两项！");
            return;
          }
          // 请将奖品填写完整！
          let isFlay = false;
          this.ladderData.forEach((item) => {
            if (!item.prizeType || !item.prizeCount) {
              isFlay = true;
            }
          });
          if (isFlay) {
            return this.$message.warning("请将奖品填写完整！");
          }

          let isFlay2 = false;
          this.ladderData.forEach((item) => {
            if (!item.orderAmtLimit || !item.itemTotalLimit) {
              isFlay2 = true;
            }
          });
          if (isFlay2) {
            return this.$message.warning(
              "请填写订单金额门槛和请填写商品件数门槛！"
            );
          }
          let isOk = false;
          for (let i = 0; i < this.ladderData.length; i++) {
            for (let j = i + 1; j < this.ladderData.length; j++) {
              if (
                Number(this.ladderData[i].orderAmtLimit) >=
                  Number(this.ladderData[j].orderAmtLimit) &&
                Number(this.ladderData[i].itemTotalLimit) >=
                  Number(this.ladderData[j].itemTotalLimit)
              ) {
                isOk = true;
              }
            }
          }
          if (isOk) {
            return this.$message.warning(
              "阶梯条件设置有误，下一个阶梯的订单金额和商品件数不能同时小于等于上一阶梯的值哦~"
            );
          }
        } else {
          if (!String(this.ruleForm.orderStartPayment)) {
            this.$message.warning("请填写订单金额");
            return;
          }
          //奖品设置最少一项
          if (this.tableData.length === 0) {
            this.$message.warning("奖品设置最少一项！");
            return;
          }
          // 请将奖品填写完整！
          let isFlay = false;
          this.tableData.forEach((item) => {
            if (!item.prizeType || !item.prizeCount) {
              isFlay = true;
            }
          });
          if (isFlay) {
            return this.$message.warning("请将奖品填写完整！");
          }
        }
        if (this.ruleForm.lockPrizeType == 1) {
          if (!this.ruleForm.lockPrizeDay) {
            this.$message.warning("请输入完成付款锁定奖品时间");
            return;
          }
        }
        //请添加曝光商品！
        if (this.ruleForm.exposureSwitch) {
          if (this.itemListFor.length === 0) {
            this.$message.warning("请添加曝光商品！");
            return;
          }
        }
        // 小程序分享标题
        if (!this.ruleForm.shareTitle) {
          this.$message.warning("请输入小程序分享标题");
          return;
        }
        // 小程序分享简介
        if (!this.ruleForm.shareIntroduce) {
          this.$message.warning("请输入小程序分享简介");
          return;
        }
        if (this.ruleForm.paperworkType == 1) {
          if (!this.customerPaperwork.title) {
            this.$message.warning("请输入活动标题");
            return;
          }
          if (!this.customerPaperwork.titleColor) {
            this.$message.warning("请选择标题文字颜色");
            return;
          }
        }
        //活动规则不能为空
        if (!this.ruleForm.activityRulesText) {
          this.$message.warning("活动规则不能为空");
          return;
        }
      }

      //判断勾选提示后即可调取接口
      if (this.checked == true || this.isDraft) {
        if (
          this.valueRow &&
          !this.activityData.isCopy &&
          !this.isDraft &&
          !this.isDraftEdit
        ) {
          let res;
          if (this.activityData.isStart) {
            console.log(cardParams);
            let params = {
              activityName: this.ruleForm.activityName,
              endTime: cardParams.endTime,
              templateId:this.templateId,
              ruleDto:cardParams.ruleDTO,
              activityId: this.valueRow.id,
              ruleDescription: cardParams.ruleDescription,
              prizes: cardParams.pointActivityPrizeDTOList
                .filter((item) => item.totalAmount)
                .map((item) => {
                  return {
                    title:item.title,
                    prizeId: item.id,
                    totalAmount: item.totalAmount,
                    isFollowActivityEndTime: item.isFollowActivityEndTime,
                    predictSendTime: item.predictSendTime,
                    addressFillEndTime: item.addressFillEndTime,
                    addressFillLimit: item.addressFillLimit,
                  };
                }),
              isExposureItem: this.ruleForm.exposureSwitch ? 1 : 0,
              itemList: this.itemListFor,
              isValidBlackList: this.ruleForm.isValidBlackList,
            };
            // if (
            //   this.orderStartTime != this.ruleForm.orderStartTime ||
            //   this.orderEndTime != this.ruleForm.orderEndTime
            // ) {
            //   params.ruleDTO = cardParams.ruleDTO;
            // }
            // if (this.actEndTime != this.ruleForm.activityEndTime) {
            //   params.endTime = this.ruleForm.activityEndTime;
            // }
            res = await updateCommon(params);
          } else {
            res = await editPurchaseActivity({
              ...cardParams,
              pointActivityId: this.valueRow.id,
            });
          }
          // editPurchaseActivity({
          //   ...cardParams,
          //   pointActivityId: this.valueRow.id,
          // }).then((res) => {
          if (res && res.code == 1) {
            this.$message.success(res.message);
            // this.$emit("saveEdit");
            this.$router.push({
              name: "throw",
              query: {
                id: res.data.id,
                activityType: res.data.activityType,
              },
            });
          } else {
            if (res.message) {
              this.$message.error(res.message);
            } else {
              this.$message.error(res.data.message);
            }
          }
          // });
        } else {
          if (this.isDraft) {
            cardParams.status = 5;
            // 草稿箱奖品填写完整校验-若不全则为空
            cardParams.pointActivityPrizeDTOList =
              cardParams.pointActivityPrizeDTOList.filter(
                (item) => item.prizeType
              );
          }
          // 草稿箱编辑-添加活动id
          if (this.isDraftEdit) {
            cardParams.id = this.valueRow.id;
          }
          if (this.activityData.isCopy) {
            delete cardParams.id;
          }
          createPurchaseActivity(cardParams).then((res) => {
            if (res.code == 1) {
              if (this.isDraft) {
                this.$message.success("保存成功！");
                this.$emit("returnBack", true);
              } else {
                this.$message.success(res.message);
                // this.$emit("saveEdit");
                this.$router.push({
                  name: "throw",
                  query: {
                    id: res.data.id,
                    activityType: res.data.activityType,
                  },
                });
              }
            } else {
              this.$message.error(res.message);
            }
          });
        }
        this.joinBlackList = false;
        return;
      } else {
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    //生成规则
    generateRule() {
      //活动规则判断
      let text1 = "参与方式：",
        text2 = "有效订单不包含售中退款/售后退款，如成功参与活动的用户对商品订单进行售后行为，导致实际支付金额不足活动门槛金额的，或者因客户原因导致的恶意退款，视为用户不符合中奖资格，商家有权取消该用户获取奖品的资格。",
        text3 = "实物奖品需填写收货地址后进行发货；若收货地址填写截止时间前未填写收货信息视为自动放弃中奖资格，奖品失效处理，且奖品不予补发！",
        text4 = "礼品数量有限，先到先得，有可能会有礼品擦肩而过情况；",
        text5 = "",
        text6 = "",
        text7 = "活动奖品：",
        text8 = "",
        text9 = "",
        test1 = "",
        test2 = "",
        test3 = "",
        test4 = "",
        test6 = "",
        text10 = "",
        secondText = "\n二、【如何参与】",
        thirdText = "\n三、【活动奖品】",
        fourthText = "\n四、【注意事项】";
        const {firstText,precautions} = this.getCommonText(this.levelList,this.ruleForm,this.ruleDto,this.actMember)

      //首单专享礼规则：
      if (this.activityData.id != 16) {
        if (this.ruleForm.days) {
          // 首单专享礼和复购规则去掉近xx天的限制，替换成如下
          text5 = `首单专享礼规则：${this.ruleForm.firstBuyRule === 1
                ? "近365天完成首单的用户；"
                : "历史首单是同品牌多店会员时是品牌历史首单，非店铺历史首单的用户；"}`;
        }
        if(this.activityData.id == 18) {
          text5 = `复购规则：${this.ruleForm.joinType == 0
                ? "已完成首单的用户再次购买；"
                : (this.ruleForm.joinType == 1 ? `近${this.ruleForm.days}天内完成下单的用户再次购买；` : `在${this.ruleForm.orderFinishStartTime}至${this.ruleForm.orderFinishEndTime}内有完成订单的用户再次购买；`)}`;
        }
      }
      // 下单时间
      if (this.ruleForm.orderStartTime && this.ruleForm.orderEndTime) {
        test1 =
          "参与规则：下单时间：" +
          this.ruleForm.orderStartTime +
          "~" +
          this.ruleForm.orderEndTime;
      }
      // 订单笔数：
      if (this.ruleForm.orderStartCount && this.ruleForm.orderEndCount) {
        test3 =
          ";商品件数：" +
          this.ruleForm.orderStartCount +
          "件~" +
          this.ruleForm.orderEndCount +
          "件；";
      }
      if (this.ruleForm.orderStartCount && !this.ruleForm.orderEndCount) {
        test3 = ";商品件数：大于等于" + this.ruleForm.orderStartCount + "件；";
      }
      if (!this.ruleForm.orderStartCount && !this.ruleForm.orderEndCount) {
        test3 = ";商品件数：不限；";
      }
      // 订单金额：
      if (this.ruleForm.orderStartPayment && this.ruleForm.orderEndPayment) {
        test2 =
          ";订单金额：" +
          this.ruleForm.orderStartPayment +
          "元~" +
          this.ruleForm.orderEndPayment +
          "元";
      }
      if (this.ruleForm.orderStartPayment && !this.ruleForm.orderEndPayment) {
        test2 = ";订单金额：大于等于" + this.ruleForm.orderStartPayment + "元";
      }
      if (this.isNongfu) {
        test4 = `;是否指定商品金额：${
          this.ruleForm.isLimitSkuAmt ? "是" : "否"
        }`;
        if (this.ruleForm.isLimitSkuAmt) {
          // 指定商品金额：
          if (
            String(this.ruleForm.skuStartPayment) &&
            this.ruleForm.skuEndPayment
          ) {
            test6 =
              ";指定商品金额：" +
              this.ruleForm.skuStartPayment +
              "元~" +
              this.ruleForm.skuEndPayment +
              "元";
          }
          test5 =
            ";指定商品:" +
            this.appointGoodsFilterArr.map((item) => item.title).join(",");
          if (
            String(this.ruleForm.skuStartPayment) &&
            !this.ruleForm.skuEndPayment
          ) {
            test6 =
              ";指定商品金额：大于等于" + this.ruleForm.skuStartPayment + "元";
          }
        }
      }
      text6 = this.activityData.id != 16 ? text5 : '';
      text8 += test1 + test2 + test3 + test4 + test6;
      let stepTypes = ['一','二','三','四','五','六','七','八','九','十']
      //奖品设置
      if (this.activityData.id == 18) {
        let prizeText = ""
        this.tableData.forEach((item, index) => {
          let result = "";
          if (item.prizeType == "1") {
            result = item.price + "元优惠券";
          } else if (item.prizeType == "2") {
            result = item.price + "京豆";
          } else if (item.prizeType == "3") {
            result = item.price + "元"
          } else if (item.prizeType == "4") {
            result = item.price + "店铺积分";
          } else if (item.prizeType == "5") {
            result = item.price + "元京东E卡";
          } else if (item.prizeType == "6") {
            result = item.price + "元的爱奇艺会员";
          } else if (item.prizeType == "7") {
            result = item.price + "元京东PLUS会员";
          } else if (item.prizeType == "8") {
            result = item.price + "元现金红包";
          } else if (item.prizeType == "10") {
            result = item.price + "张礼品卡";
          }
          if (item.price && item.prizeCount) {
            // if(item.prizeType=='4') {
            //   item.title= "店铺积分"
            // }
            prizeText += `（${index+1}）奖品${index + 1}：${item.title}，共${item.prizeCount}份${item.prizeType==3 ? ('，单份奖品价值'+result) : ''}；`;
            if(index<this.tableData.length-1) {
              prizeText += "\n"
            }
          }
        });
        let stepPrizeText = ""
        this.ladderData.forEach((item, index) => {
          let result = "";
          if (item.prizeType == "1") {
            result = item.price + "元优惠券";
          } else if (item.prizeType == "2") {
            result = item.price + "京豆";
          } else if (item.prizeType == "3") {
            result = item.price + "元";
          } else if (item.prizeType == "4") {
            result = item.price + "店铺积分";
          } else if (item.prizeType == "5") {
            result = item.price + "元京东E卡";
          } else if (item.prizeType == "6") {
            result = item.price + "元爱奇艺会员";
          } else if (item.prizeType == "7") {
            result = item.price + "元京东PLUS会员";
          } else if (item.prizeType == "8") {
            result = item.price + "元现金红包";
          } else if (item.prizeType == "10") {
            result = item.price + "张礼品卡";
          }
          if (item.price && item.prizeCount) {
            // if(item.prizeType=='4') {
            //   item.title= "店铺积分"
            // }
            stepPrizeText += `（${index+1}）阶梯${stepTypes[index]}（订单金额满${item.orderAmtLimit}元，且满${item.itemTotalLimit}件，有机会得该阶梯奖品）\n奖品${index + 1}：${item.title}，共${item.prizeCount}份${item.prizeType==3 ? ('，单份奖品价值'+result) : ''};`;
            if(index<this.ladderData.length-1) {
              stepPrizeText += "\n"
            }
          }
        });

        if(this.ruleForm.prizeSettingType==0) {
          text7 += `统一奖品（订单金额满${this.ruleForm.orderStartPayment}元，且满${this.ruleForm.orderStartCount}件）\n` + prizeText
        } else {
          text7 += "阶梯奖品\n" + stepPrizeText
        }
      } else {
        let prizeText = ""
        this.tableData.forEach((item, index) => {
          let result = "";
          if (item.prizeType == "1") {
            result = item.price + "元优惠券";
          } else if (item.prizeType == "2") {
            result = item.price + "京豆";
          } else if (item.prizeType == "3") {
            result = item.price + "元";
          } else if (item.prizeType == "4") {
            result = item.price + "店铺积分";
          } else if (item.prizeType == "5") {
            result = item.price + "元京东E卡";
          } else if (item.prizeType == "6") {
            result = item.price + "元爱奇艺会员";
          } else if (item.prizeType == "7") {
            result = item.price + "元京东PLUS会员";
          } else if (item.prizeType == "8") {
            result = item.price + "元现金红包";
          } else if (item.prizeType == "10") {
            result = item.price + "张礼品卡";
          }
          if (item.price && item.prizeCount) {
            // if(item.prizeType=='4') {
            //   item.title= "店铺积分"
            // }
            prizeText += `（${index+1}）奖品${index + 1}：${item.title}，共${item.prizeCount}份${item.prizeType==3 ? ('，单份奖品价值'+result) : ''};`;
            if(index<this.tableData.length-1) {
              prizeText += "\n"
            }
          }
        });
        let stepPrizeText = ""
        this.ladderData.forEach((item, index) => {
          let result = "";
          if (item.prizeType == "1") {
            result = item.price + "元优惠券";
          } else if (item.prizeType == "2") {
            result = item.price + "京豆";
          } else if (item.prizeType == "3") {
            result = item.price + "元";
          } else if (item.prizeType == "4") {
            result = item.price + "店铺积分";
          } else if (item.prizeType == "5") {
            result = item.price + "元京东E卡";
          } else if (item.prizeType == "6") {
            result = item.price + "元爱奇艺会员";
          } else if (item.prizeType == "7") {
            result = item.price + "元京东PLUS会员";
          } else if (item.prizeType == "8") {
            result = item.price + "元现金红包";
          } else if (item.prizeType == "10") {
            result = item.price + "张礼品卡";
          }
          if (item.price && item.prizeCount) {
            // if(item.prizeType=='4') {
            //   item.title= "店铺积分"
            // }
            let orderTypes = {
              0: "单笔订单",
              1: "累计订单"
            }
            stepPrizeText += `（${index+1}）阶梯${stepTypes[index]}（${orderTypes[this.ladder.orderCountType]}满${item.orderAmtLimit}元，且满${item.itemTotalLimit}件，有机会得该阶梯奖品）\n奖品${index + 1}：${item.title}，共${item.prizeCount}份${item.prizeType==3 ? ('，单份奖品价值'+result) : ''};`;
            if(index<this.ladderData.length-1) {
              stepPrizeText += "\n"
            }
          }
        });
        if(this.ruleForm.prizeSettingType==0) {
          text7 += `${this.activityData.id == 16 ?'统一奖品\n' : '\n'}`
          text7+=prizeText
        } else {
          text7 += "阶梯奖品\n" + stepPrizeText
        }
      }
      if(this.activityData.id == 17) {
        if(this.ruleForm.lockPrizeType==0) {
          text9 += "锁定奖品：达成条件领取奖品：需用户达成订单条件且订单状态已完成才可进入活动页领取奖品；"
        } else {
          text9 += `锁定奖品：完成付款锁定奖品${this.ruleForm.lockPrizeDay}日：用户达成订单条件且已付款后，可进行锁定奖品${this.ruleForm.lockPrizeDay}日，到指定日期用户达成完成订单条件奖品自动发放;(期间取消订单即发放失败，回归奖品库存)`
        }
      }
      if(this.activityData.id == 17||this.activityData.id == 18) {
        if(this.ruleForm.supportCancelOrderRebind==1) {
          text10 = "是否支持订单取消后可重新绑定其他订单领取奖品：支持重新绑定领取"
        } else {
          text10 = "是否支持订单取消后可重新绑定其他订单领取奖品：不支持重新绑定领取"
        }
      }
      if(this.activityData.id == 16||this.activityData.id == 18) {
        text1+= "报名时间范围内，进入活动手动解锁参与；"
      } else {
        text1+= "活动有效期范围内，进入活动手动解锁参与；"
      }
      let textShop = "下单店铺：";
      if(this.ruleDto.venderIds.length > 0) {
        this.ruleDto.venderIds.forEach((item, index) => {
          const shop = this.shopList.find(v=> v.venderId == item);
          if(shop) {
            textShop += shop.shopTitle;
            if(index < this.ruleDto.venderIds.length-1) {
              textShop += "、"
            }
          }
        })
      }
      let Arr1 = [];
      if (this.activityData.id == 18) {
        Arr1 = [
          firstText,
          [secondText,text1,textShop,text6,text8,text2,text3,text4],
          [thirdText, text7,text10],
          [fourthText, precautions]
        ];
      } else {
        Arr1 = [
          firstText,
          [secondText,text1,textShop,text6,text8,text2,text3,text4],
          [thirdText, text7,text9,text10],
          [fourthText, precautions]
        ];
      }
      let newText = "";

      Arr1.forEach((item, index) => {
        let newNum = 0;
        item.forEach((row, it) => {
          if (row.length > 0) {
            if (it != 0) {
              newText = newText + newNum + "." + row + "\n";
            } else {
              newText = newText + row + "\n";
            }
            newNum = newNum + 1;
          }
        });
      });
      this.ruleForm.activityRulesText = newText;
    },
    exposureSwitchChange(val) {
      if (!val) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
    },
    testParmasSwitchChange(val) {
      if (!val) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
    },
    filterTypeChange(val) {
      if (val == "0") {
        this.itemListForFilter = [];
        this.selectGoodsFilterArr = [];
      } else if (val == "1") {
        this.selectGoodsFilterArr = this.includeArr;
        this.itemListForFilter = this.includeArr;
      } else if (val == "2") {
        this.selectGoodsFilterArr = this.excludeArr;
        this.itemListForFilter = this.excludeArr;
      }
      this.ruleDto.filterSkuType = 0;
    },
    //添加曝光商品弹窗
    exposureProducts() {
      this.selectGoodsState = true;
      // console.log(this.itemListFor);
      if (this.itemListFor.length == 0) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
      this.$refs.selectGo.handleRightCurrentChange(1);
    },
    //指定购买商品商品弹窗
    exposureProductsFiter() {
      this.selectGoodsStateFilter = true;
      // console.log(this.itemListFor);
      if (this.itemListForFilter.length == 0) {
        this.itemListForFilter = [];
        this.selectGoodsFilterArr = [];
        // this.mainImagelist = [];
      }
      // 根据类型显示商品
      if (this.ruleForm.filterType == "1") {
        this.selectGoodsFilterArr = this.includeArr;
        this.itemListForFilter = this.includeArr;
      } else if (this.ruleForm.filterType == "2") {
        this.selectGoodsFilterArr = this.excludeArr;
        this.itemListForFilter = this.excludeArr;
      }
      this.$refs.selectGoFilter.handleRightCurrentChange(1);
    },

    // 指定金额商品
    appointProductsFiter() {
      this.showAppointFilter = true;
      if (this.appointListForFilter.length == 0) {
        this.appointListForFilter = [];
        this.appointGoodsFilterArr = [];
      }
      this.$refs.appointFilter.handleRightCurrentChange(1);
    },

    selectGoodsSure(data) {
      if (!data) {
        this.selectGoodsStateFilter = false;
        return;
      }
    },
    selectGoodsClose(data) {
      console.log(data, 222);
      if (data) {
        console.log(data);
        this.itemListFor = [];
        this.mainImagelist = [];
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].wareTitle || data[index].title;
          this.itemListFor.push(fomeVaule);
          this.mainImagelist.push(fomeVaule);
        });
        console.log(this.mainImagelist);
        this.selectGoodsArr = this.itemListFor;
      }
      // console.log(this.selectGoodsArr, this.itemListFor, 3333);
      this.selectGoodsState = false;
    },
    //选择商品数据 曝光
    selectGoodsCloseFilter(data) {
      console.log(data, 11111);
      if (data) {
        console.log(data);
        this.itemListForFilter = [];
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].wareTitle || data[index].title;
          this.itemListForFilter.push(fomeVaule);
          // this.mainImagelist.push(fomeVaule);
        });
        if (this.ruleForm.filterType == 1) {
          this.includeArr = this.itemListForFilter;
        } else if (this.ruleForm.filterType == 2) {
          this.excludeArr = this.itemListForFilter;
        }
        this.selectGoodsFilterArr = this.itemListForFilter;

        let valArr = [];
        data.forEach((i) => {
          valArr.push(i.skuId);
        });
        this.selectGoodsFilterArr = data;
        this.ruleDto.sellerSkuList.forEach((item)=> {
          if(item.venderId == this.curretnVenderId) {
            item.skuIds = valArr;
            item.itemList = data
          }
        })
      }
      // console.log(this.selectGoodsArr, this.itemListFor, 3333);
      this.selectGoodsStateFilter = false;
    },

    appointGoodsCloseFilter(data) {
      if (data) {
        this.appointListForFilter = [];
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].wareTitle || data[index].title;
          this.appointListForFilter.push(fomeVaule);
        });
        this.appointGoodsFilterArr = this.appointListForFilter;
      }
      this.showAppointFilter = false;
    },

    //选中改变
    checkListchange(val) {
      console.log(val);
      console.log(this.levelList);
      val.forEach((low) => {
        if (low == -1) {
          this.ruleForm.partner = ["-1"];
        }
      });
    },
    // 品牌定制弹窗
    handleOpen() {
      const href =
        "tencent://message/?uin=800152084&Site=%E5%9C%A8%E7%BA%BF%E5%AE%A2%E6%9C%8D&Menu=yes";
      window.open(href, "_self");
    },
    //输入框限制负数
    checkputn(e, row = {}, type = "nojingdou") {
      if (type == "nojingdou") {
        let filtered = e.target.value.replace(/^0|[^\d]/g, "");
        e.target.value = Number(filtered);
        if (e.target.value < 1) {
          e.target.value = "";
        }
      } else {
        if (
          row.quantityTotal &&
          row.price &&
          row.prizeCount &&
          row.prizeType == 2
        ) {
          let numTotal = this.$jingdouTotal(row);
          if (!numTotal) {
            this.$message.warning("京豆总份额数量不能大于该京豆预算额！");
          }
          return numTotal;
        } else {
          return row.prizeCount;
        }
      }
    },
    //输入正数、一个小数点
    checkputnPositive(e) {
      e.target.value = e.target.value
        .replace(".", "$#$")
        .replace(/\./g, "")
        .replace("$#$", ".")
        .replace(/[^\d.]/g, "");
      // e.target.value = Number(filtered);
      let filtered = e.target.value;
      if (Number(filtered) < 1) {
        e.target.value = "";
      }
    },

    //曝光商品
    exposureChange(val) {
      if (val == "0") {
        this.ruleForm.exposureSwitch = false;
        this.itemListFor = [];
      } else {
        this.ruleForm.exposureSwitch = true;
      }
    },
    clickLocalStep() {
      if (this.backgroundOpacity) {
        this.$emit("returnBack");
        return;
      }
      if (!this.activityData.isCopy && this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      if (this.activityData.isCopy) return (this.localStep = 0);
      this.localStep = 0;
      this.localStepNum = 0;
      this.ruleForm.radio = 0;
      this.ruleForm.exposureSwitch = false;
      this.itemListFor = [];
      this.ruleForm.activityName = ""; //活动类型  13: 开卡礼包 14: 店铺礼包
      this.ruleForm.activityStartTime = "";
      this.ruleForm.activityEndTime = "";
      this.selectGoodsStateFilter = false;
      this.itemListForFilter = [];
      this.selectGoodsFilterArr = [];
      this.appointGoodsFilterArr = [];
      this.appointListForFilter = [];
      this.ruleForm.condFollow = false; // 是否需要关注店铺
      this.ruleForm.days = "100"; //近X天内未购
      this.ruleForm.orderStartTime = ""; //下单开始时间
      this.ruleForm.orderEndTime = ""; //下单结束时间
      this.ruleForm.orderStartCount = ""; //订单开始笔数
      this.ruleForm.orderEndCount = ""; //订单结束笔数
      this.ruleForm.orderStartPayment = ""; //订单开始金额
      this.ruleForm.orderEndPayment = ""; //订单结束金额
      this.ruleForm.filterType = "0"; //过滤商品：0全部商品 1指定商品 2排除商品
      this.ruleForm.skuIdList = []; //skuId集合，多个，隔开
      this.ruleForm.isLimitSkuAmt = false; // 是否选择指定商品金额
      this.ruleForm.skuStartPayment = ""; // 指定商品结开始金额
      this.ruleForm.skuEndPayment = ""; // 指定商品结束金额
      this.tableData = [
        {
          peopleCount: "",
          prizeType: "",
          discount: "",
          prizeCount: "",
          singleAmount: "",
        },
      ];
      this.mainImagelist = []; //图片拖拽排序
      this.isDragging = false;
      this.itemListFor = []; //商品弹框选择商品数据
      this.selectGoodsState = false; //曝光商品弹窗
      this.ruleForm.activityRulesText = "";
      this.$emit("titopName", this.activityData.name, false);
    },
    handleCreate() {
      window.open(
        "https://fw.jd.com/main/detail/FW_GOODS-1631?p=fw&t=pcsearch",
        "_self"
      );
    },
    // 只输入文字判断
    handleInput(value) {
      let num = value.replace(/[^\d]/g, "").replace(/^0+(\d)/, "$1");
      this.$forceUpdate();
      return num;
    },
    updateInputBox() {
      let num = Number(this.ruleForm.days);
      if (num < 1) {
        this.ruleForm.days = 1;
      } else if (num > 180) {
        this.ruleForm.days = 180;
      }
    },
    handleChange() {
      this.$forceUpdate();
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.titleBox){
  margin: 16px 0;
}

.condition {
  font-weight: 700;
  margin-left: 20px;
}

.nong_fu_icon {
  margin-left: 4px;
  padding-top: 2px;
  cursor: pointer;

  .tips {
    display: none;
  }

  &:hover {
    .tips {
      color: red;
      font-size: 14px;
      display: inline-block;
      margin-left: 12px;
    }
  }
}

.memberTips {
  color: red;
}
.dataPicker {
  /deep/.el-button--text {
    display: none !important;
  }
}

/deep/ .el-table__body-wrapper {
  overflow: visible !important;
}

/deep/ .tableData .el-table {
  overflow: visible !important;
}

/deep/ .el-table__row:hover {
  .delQx {
    display: flex;
  }
}
.orangeColor {
  color: #fe4d45;
}
.ruloBox {
  width: 860px;
  height: 69px;
  background: #fffaee;
  border-radius: 4px;
  color: #333333;
  padding-left: 12px;
  margin-bottom: 10px;
  padding-top: 10px;
  line-height: 26px;
}
.del_box {
  position: absolute;
  left: 150px;
  top: 10px;
  width: 50px;
  height: 50px;
}
.del_box2 {
  position: absolute;
  left: 180px;
  top: 10px;
  width: 50px;
  height: 50px;
}
.delQx {
  width: 25px;
  height: 25px;
  background: rgb(255, 76, 68) !important;
  display: inline-block;
  display: none;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  img {
    width: 50px;
    margin-right: 4px;
  }
  // display: none;
}
.del_box1 {
  position: absolute;
  left: 145px;
  top: 15px;
  width: 50px;
  height: 50px;
}
.giftBottom {
  position: absolute;
  bottom: 19%;
  left: 50%;
  transform: translateX(-50%);
  // background: red;
  width: 112px;
  height: 24px;
  display: block;
  text-align: center;
  line-height: 24px;
  color: red;
  opacity: 0.7;
  font-weight: 600;
}
.giftImg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.rule_box {
  width: 860px;
  // height: 217px;
  background: #fafafa;
  padding-bottom: 10px;
  border-radius: 4px;
  font-size: 14px;
  &_top {
    margin: 15px 0 10px 15px;
  }
  &_middle {
    margin-left: 10px;
    .middle-box {
      display: flex;
      align-items: center;
      &_tip {
        color: #ff0000;
      }
    }
  }
  &_bottom {
    margin-left: 7px;
  }
}
.active-width {
  width: 1300px;
}
.rule_prize {
  margin-top: 20px;
  width: 1050px;
  background: #fafafa;
  padding: 20px;
  border-radius: 4px;
  font-size: 14px;
}
.shopDiaog {
  width: 60px;
  height: 26px;
  background: #ffffff;
  display: inline-block;
  line-height: 26px;
  text-align: center;
  border-radius: 4px;
  border: 1px solid #000;
  &:hover {
    border: 1px solid #fe4d45;
    color: #fe4d45;
  }
}
.tooltipBox {
  box-sizing: border-box;
  height: 485px;
  // width: 100%;
  // height: 100%;
  // background: red;
  // box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.16);
  padding: 30px;
  display: inline-flex;
  &-left {
    width: 253px;
    height: 417px;
    position: relative;
    margin-right: 30px;
    // .tooltipheis {
    //   width: 128px;
    //   height: 417px;
    //   position: absolute;
    //   border: 2px dashed #666666;
    //   top: 0px;
    //   left: -50%;
    // }
    .tooltipBoder {
      width: 184px;
      height: 273px;
      position: absolute;
      border: 2px dashed #2fd461;
      top: 50%;
      left: 46%;
      transform: translate(-50%, -50%);
      border-radius: 4px;
      &::after {
        content: "";
        width: 53px;
        border-top: 2px dashed #2fd461;
        display: block;
        position: absolute;
        right: -55px;
        top: 25px;
      }

      &::before {
        content: "";
        width: 16px;
        border-top: 2px dashed #fe4d45;
        display: block;
        position: absolute;
        right: -63px;
        top: 88px;
      }
    }
    .tooltipliji {
      position: absolute;
      bottom: 80px;
      left: 47%;
      transform: translateX(-50%);
      width: 154px;
      height: 42px;
      border: 2px dashed #fe4d45;
      border-radius: 4px;
      &::before {
        content: "";
        width: 50px;
        border-top: 2px dashed #fe4d45;
        display: block;
        position: absolute;
        right: -55px;
        top: 19px;
      }
      &::after {
        content: "";
        height: 150px;
        border-right: 2px dashed #fe4d45;
        display: block;
        position: absolute;
        right: -60px;
        top: -131px;
      }
    }
  }
  &-right {
    width: 368px;
    height: 100%;
    .p1 {
      font-size: 15px;
      font-weight: 500;
      line-height: 21px;
      color: #333333;
    }
    .p2 {
      font-size: 13px;
      font-weight: 400;
      line-height: 21px;
      color: #666666;
    }
  }
}
.qx {
  padding-top: 8px;
  padding-bottom: 8px;
}
.crowd {
  padding-left: 50px;
  margin-bottom: 20px;
  &-point {
    color: #999999;
    margin-bottom: 8px;
    position: relative;
    padding-left: 8px;
    &::before {
      position: absolute;
      top: 0px;
      left: 0px;
      width: 3px;
      height: 14px;
      background: #fe4d45;
      border-radius: 3px;
      content: "";
      display: block;
    }
  }
  &-tab {
    width: 100%;
    &-head {
      width: 100%;
      height: 48px;
      padding-left: 30px;
      background: #fafafa;
    }
    &-sm {
      display: inline-block;
      width: 87%;
      color: #666;
      // line-height: 48px;
      position: relative;
    }
    &-name {
      display: inline-block;
      width: 13%;
      line-height: 48px;
    }
    &-middle {
      padding-left: 30px;
      border: 1px solid #f0f0f0;
      border-left: none;
      border-right: none;
      display: flex;
    }
    .descbox {
      // top: -8px;
      display: flex;
      justify-items: center;
      align-items: center;
      flex-wrap: wrap;
    }
    .dx {
      // position: absolute;
      // top: 19px;
      width: 100%;
    }
    .nameAlign {
      display: flex;
      height: 48px;
      align-items: center;
    }
  }
}
.card-point {
  width: 100%;
  background: #fffaee;
  border-radius: 4px;
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 12px 0px 12px 20px;
  display: flex;
  .card-rule {
    margin-left: 12px;
    padding-left: 18px;
    width: 90px;
    background: url("https://cdn-image.yucrm.cn/images/jd-front-platform/images/new_icon_reminder.png") no-repeat;
    background-size: 14px 14px;
    margin-top: 4px;
  }
  .card-connet {
    p {
      line-height: 22px;
      font-size: 14px;
      color: #333333;
    }
  }
}

.startTime {
  /deep/ .el-input__inner {
    padding-left: 30px !important;
  }
}
.prosi {
  position: absolute;
  bottom: 8px;
  right: 30px;
}
.desc {
  i {
    opacity: 0.7;
    color: #fe4d45;
  }
  color: #999;
}

.flex {
  display: flex;
  align-items: center;
}
.prize_box {
  padding: 26px 21px;
  background: #fcfcfc;
  .tips {
    width: 600px;
    display: flex;
    align-items: center;
    // align-items: flex-start;
    box-sizing: border-box;
    background: #fffaee;
    border-radius: 3px;
    font-size: 14px;
    font-weight: 400;
    color: #333;
    margin-bottom: 9px;
  }
  .add_btn {
    cursor: pointer;
    color: #7f85e9;
    border: 1px dashed #7f85e9;
    width: 520px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 8px;
  }
  .add_btn1 {
    cursor: pointer;
    color: #fe4d45;
    border: 1px solid #fe4d45;
    width: 90px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(254, 77, 69, 0.1);
    border-radius: 4px;
    margin-top: 8px;
  }
}
.line {
  display: flex;
  align-items: center;
}
.createPlayStep {
  position: relative;
  box-sizing: border-box;
  height: 100%;
  background-color: #fff;
  border-radius: 6px;
  // margin: 11px 20px;
  .headReturn {
    box-sizing: border-box;
    padding-left: 30px;
    width: 100%;
    height: 50px;
    line-height: 49px;
    border-bottom: 1px solid #f3f3f3;
    span {
      color: #ccc;
      cursor: pointer;
    }
    .name {
      color: #333;
      cursor: default;
    }
  }
  .firststep {
    min-height: 820px;
    box-sizing: border-box;
    padding: 0px 35px 0;
    .tishi {
      // height: 20px;
      font-size: 14px;
      font-weight: 400;
      line-height: 22px;
      color: #333333;
      background: #fffaee;
      border-radius: 4px;
      margin-bottom: 20px;
      padding: 14px 20px;
    }
    .itemList {
      display: flex;
      .item {
        width: 100%;
        flex: 1;
        box-sizing: border-box;
        position: relative;
        color: #666;
        text-align: center;
        padding: 6px;
        &:hover {
          .border::before,
          .border::after {
            opacity: 1;
            transform: scale(1);
          }
        }
        .border {
          position: absolute;
          left: 0;
          top: 0;
          // width: 100%;
          height: 100%;
          width: 253px;
          border-radius: 4px;
          &::before,
          &::after {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            content: "";
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.8s, transform 0.8s;
            border-radius: 4px;
          }
          &::before {
            border-top: 1px solid #fe4d45;
            border-bottom: 1px solid #fe4d45;
            -webkit-transform: scale(0, 1);
            transform: scale(0, 1);
          }
          &::after {
            border-right: 1px solid #fe4d45;
            border-left: 1px solid #fe4d45;
            -webkit-transform: scale(1, 0);
            transform: scale(1, 0);
          }
        }

        .wrapper-kaika {
          width: 100%;
          height: 100%;
          display: grid;
          // align-items: center;
          // justify-content: center;

          &-img {
            background-color: #fafafa;
            border: 2px solid rgba(254, 77, 69, 0.0784313725490196);
            border-radius: 8px;
            height: 350px;
            // margin-right: 20px;
            position: relative;
            &:hover {
              .borderkaika::before,
              .borderkaika::after {
                opacity: 1;
                transform: scale(1);
              }
            }
            .borderkaika {
              position: absolute;
              left: -6px;
              top: -6px;
              width: 218px;
              height: 360px;
              border-radius: 4px;
              &::before,
              &::after {
                position: absolute;
                top: 0;
                right: 0;
                bottom: 0;
                left: 0;
                content: "";
                opacity: 0;
                pointer-events: none;
                transition: opacity 0.8s, transform 0.8s;
                border-radius: 4px;
              }
              &::before {
                border-top: 1px solid #fe4d45;
                border-bottom: 1px solid #fe4d45;
                -webkit-transform: scale(0, 1);
                transform: scale(0, 1);
              }
              &::after {
                border-right: 1px solid #fe4d45;
                border-left: 1px solid #fe4d45;
                -webkit-transform: scale(1, 0);
                transform: scale(1, 0);
              }
            }

            div {
              font-size: 18px;
              font-weight: bold;
              // line-height: 25px;
              color: #333333;
            }
            img {
              width: 32px;
              height: 32px;
            }

            .queryIdIMG {
              display: none;
            }
            &:hover {
              .queryIdIMG {
                display: block;
              }
              .mask {
                opacity: 1;
              }
            }
            .mask {
              display: flex;
              flex-direction: column;
              justify-content: center;
              position: absolute;
              left: 0;
              top: 0;
              right: 0;
              bottom: 0;
              background-color: rgba(0, 0, 0, 0.6);
              color: #fff;
              opacity: 0;
              transition: all 0.2s;
              .img {
                max-width: 130px;
                margin: 0 auto 30px;
                .imgBg {
                  box-sizing: border-box;
                  height: 129px;
                  width: 129px;
                  padding: 6px;
                  border-radius: 6px;
                  background-color: #fff;
                }
                .tpl {
                  display: inline-block;
                  font-size: 14px;
                  color: #fff;
                  margin-top: 10px;
                  // opacity: 0.7;
                }
              }
            }
          }
          &-tanchuang {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
          .lijijq {
            &::after {
              content: "立即领取";
              display: block;
              position: absolute;
              bottom: 9px;
              left: 51%;
              transform: translateX(-50%);
              font-size: 14px;
              // font-family: system-ui;
              font-family: PingFang SC;
              font-weight: bold;
              color: #ed6e09;
              text-shadow: 0 0 black;
            }
          }
        }
        .wrapper {
          position: relative;
          height: 350px;
          border-radius: 6px;
          overflow: hidden;
          display: grid;
          .queryId {
            display: none;
          }
          &:hover {
            .queryId {
              display: block;
            }
            .mask {
              opacity: 1;
            }
          }
          .mask {
            width: 240px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.6);
            color: #fff;
            opacity: 0;
            transition: all 0.2s;
            .img {
              max-width: 130px;
              margin: 0 auto 30px;
              .imgBg {
                box-sizing: border-box;
                height: 129px;
                width: 129px;
                padding: 6px;
                border-radius: 6px;
                background-color: #fff;
              }
              .tpl {
                display: inline-block;
                margin-top: 10px;
                color: #fff;
                // opacity: 0.7;
              }
            }
          }
        }
      }
    }
  }
  .secondstep {
    min-height: 870px;
    box-sizing: border-box;
    position: relative;
    padding: 0px 28px 1px 24px;
    margin-bottom: 29px;
    .time2 {
      width: 54px;
      height: 28px;
      border-radius: 4px;
      display: inline-block;
      text-align: center;
      line-height: 28px;
    }
    .generate {
      width: 76px;
      margin: 8px 8px 0 0;
      background: rgba(254, 77, 69, 0.1);
      border: 1px solid rgba(254, 77, 69, 1);
      color: #fe4d45;
    }
    .lastTime {
      margin-left: 20px;
      font-size: 14px;
      i {
        color: #ccc;
      }
    }
    .theLag {
      position: relative;
      margin-top: 10px;
      width: 280px;
      height: 120px;
      .theBox {
        height: 120px;
        width: 280px;
        // border: 1px solid #999;
        background: url('https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/yhq.png');
        border-radius: 8px;
        position: absolute;
        color: #333333;
        .discount_sty {
          // font-family: DIN;
          font-family: PingFang SC;
          font-weight: bold;
          color: #fe4d45;
          font-size: 45px;
        }
        .pp {
          width: 280px;
          text-align: center;
          bottom: 0px;
        }
      }
      .btnQx {
        display: none;
      }
      &:hover {
        .btnQx {
          display: block;
          position: absolute;
          top: 50%;
          left: 50%;
          margin: -16px 0 0 -49px;
        }
        .backgrd {
          width: 280px;
          height: 120px;
          background: #fff;
          position: absolute;
          border-radius: 8px;
          opacity: 0.7;
        }
      }
    }

    .productImg {
      margin-top: 10px;
      background-color: #fafafa;
      min-height: 80px;
      width: 800px;
      border-radius: 5px;
    }
    .rule-tip {
      width: 543px;
      margin-top: 8px;
      margin-left: 7px;
    }
    .act-tip {
      white-space: nowrap;
      color: #ff0000;
    }
  }

  .wrapper-kaika-img {
    width: 210px;
    height: 374px;
    margin-bottom: 40px;
  }
}
@media (min-width: 1080px) and (max-width: 1319px) {
  .wrapper-kaika {
    grid-template-columns: repeat(4, 1fr);
  }
}
@media (min-width: 1320px) and (max-width: 1589px) {
  .wrapper-kaika {
    grid-template-columns: repeat(5, 1fr);
  }
}
@media (min-width: 1590px) and (max-width: 1899px) {
  .wrapper-kaika {
    grid-template-columns: repeat(6, 1fr);
  }
}
@media (min-width: 1900px) {
  .wrapper-kaika {
    grid-template-columns: repeat(7, 1fr);
  }
}
.miniAppPic {
  position: relative;
  .image-slot {
    width: 100%;
    height: 100%;
    background: #f5f7fa;
    text-align: center;
    padding-top: 43px;
    i {
      font-size: 30px;
      color: #909399;
    }
  }
  .top {
    position: relative;
    left: 8px;
    display: flex;
    .returnBtn {
      border-radius: 4px;
      width: auto;
      height: 32px;
      line-height: 32px;
      text-align: center;
      color: #fe4d45;
      background: rgba(254, 77, 69, 0.1);
      border: 1px solid #fe4d45;
      &:hover {
        color: #fff;
        background: #fe4d45;
      }
    }
    .reset {
      color: #2768ff;
      cursor: pointer;
      font-size: 14px;
      margin-left: 15px;
    }
  }
  .bottom {
    position: relative;
    top: 15px;
    margin-left: 115px;
    .elImg {
      width: 120px;
      height: 120px;
      border: 1px dashed #dddddd;
      border-radius: 5px;
    }
    .tips1 {
      position: absolute;
      left: 135px;
      top: 22px;
      line-height: 2;
      color: #aaaaaa;
      font-size: 13px;
    }
  }
}

.lock-input {
  margin: 0 8px;
  width: 90px;
}

.tip-icon {
  cursor: pointer;
  color: #ccc;
}
</style>

<style lang="scss">
.createPlayStep {
  // .el-step.is-horizontal .el-step__line {
  //   height: 1px;
  // }
  // .el-step__head.is-success {
  //   color: #fe4d45;
  //   border-color: #fe4d45;
  //   .el-step__line {
  //     background-color: #fe4d45;
  //   }
  // }
  // .el-step__head.is-process {
  //   color: #fe4d45;
  //   border-color: #fe4d45;
  // }
  // .el-step__title.is-process {
  //   color: #fe4d45;
  // }
  // .el-step__title.is-success {
  //   color: #fe4d45;
  // }
  .textareabox {
    .el-textarea__inner {
      min-height: 80px !important;
    }
  }
  .textarea {
    .el-textarea__inner {
      min-height: 120px !important;
    }
  }
  .el-step__main {
    position: absolute;
    top: -7px;
    left: 33px;
  }
  .el-step__head.is-process {
    position: absolute;
  }
  .el-step.is-horizontal .el-step__line {
    left: 107px;
    right: 15px;
  }
  .el-step {
    position: relative;
  }
}
.tooplitMax {
  max-width: 1000px !important;
}
.support {
  display: flex;
  align-items: center;
  &-text {
    margin: 0px 8px;
  }
  &-icon {
    color: #ccc;
    cursor: pointer;
  }
}
.flex-jc {
  display: flex;
  // justify-content: space-between;
}
.preview-right {
  margin-left: 166px;
}

.ml-8 {
  margin-left: 8px;
}

.mr-8 {
  margin-right: 8px;
}
.shoptitle-label {
  margin-right: 12px;
  min-width: 60px;
  text-align: right;
  font-size: 12px !important;
}
</style>
